/* tslint:disable */
/* eslint-disable */
/**
 * MIT Learn API
 * MIT public API
 *
 * The version of the OpenAPI document: 0.0.1 (v0)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from "./common"
import type { RequestArgs } from "./base"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base"

/**
 * Serializer for attestations.
 */
export interface Attestation {
  id: number
  /**
   * Get the avatar image URL
   */
  avatar: string | null
  /**
   * Get the avatar_small image URL
   */
  avatar_small: string | null
  /**
   * Get the avatar_medium image URL
   */
  avatar_medium: string | null
  /**
   * Get the cover image URL
   */
  cover: string | null
  created_on: string
  updated_on: string
  /**
   * The name of the attestant
   */
  attestant_name: string
  /**
   * The attestant\'s title
   */
  title: string
  /**
   * The testimonial attestation
   */
  quote: string
  /**
   * The position the attestation should occupy
   */
  position?: number
  /**
   * The datetime to show the testimonial
   */
  publish_date?: string | null
  /**
   * Channels that the testimonial belongs to
   */
  channels?: Array<number>
  /**
   * The offerors that this attestation can appear on
   */
  offerors?: Array<string>
}
/**
 * * `dated` - Dated * `anytime` - Anytime
 */

export const AvailabilityEnumDescriptions = {
  dated: "Dated",
  anytime: "Anytime",
} as const

export const AvailabilityEnum = {
  /**
   * Dated
   */
  Dated: "dated",
  /**
   * Anytime
   */
  Anytime: "anytime",
} as const

export type AvailabilityEnum =
  (typeof AvailabilityEnum)[keyof typeof AvailabilityEnum]

export const BlankEnumDescriptions = {
  "": "",
} as const

export const BlankEnum = {
  Empty: "",
} as const

export type BlankEnum = (typeof BlankEnum)[keyof typeof BlankEnum]

/**
 * Serializer for CKEditor settings
 */
export interface CKEditorSettings {
  /**
   * Get the JWT token
   */
  token: string | null
}
/**
 * Serializer for caption URL entries
 */
export interface CaptionUrl {
  language: string
  language_name: string
  url: string
}
/**
 * * `yes` - Yes, I am looking for a certificate * `no` - No, I am not looking for a certificate * `not-sure-yet` - Not Sure
 */

export const CertificateDesiredEnumDescriptions = {
  yes: "Yes, I am looking for a certificate",
  no: "No, I am not looking for a certificate",
  "not-sure-yet": "Not Sure",
} as const

export const CertificateDesiredEnum = {
  /**
   * Yes, I am looking for a certificate
   */
  Yes: "yes",
  /**
   * No, I am not looking for a certificate
   */
  No: "no",
  /**
   * Not Sure
   */
  NotSureYet: "not-sure-yet",
} as const

export type CertificateDesiredEnum =
  (typeof CertificateDesiredEnum)[keyof typeof CertificateDesiredEnum]

/**
 * @type Channel
 */
export type Channel =
  | ({ channel_type: "department" } & DepartmentChannel)
  | ({ channel_type: "pathway" } & PathwayChannel)
  | ({ channel_type: "topic" } & TopicChannel)
  | ({ channel_type: "unit" } & UnitChannel)

/**
 * Serializer for resource counts associated with Channel
 */
export interface ChannelCounts {
  id: number
  counts: Counts
  /**
   * Get the URL for the channel
   */
  channel_url: string
  created_on: string
  updated_on: string
  name: string
  title: string
  channel_type: ChannelTypeEnum
  search_filter?: string
}

/**
 * Serializer for the ChannelDepartmentDetail model
 */
export interface ChannelDepartmentDetail {
  department?: string | null
}
/**
 * Serializer for the ChannelTopicDetail model
 */
export interface ChannelTopicDetail {
  topic?: number | null
}
/**
 * * `topic` - Topic * `department` - Department * `unit` - Unit * `pathway` - Pathway
 */

export const ChannelTypeEnumDescriptions = {
  topic: "Topic",
  department: "Department",
  unit: "Unit",
  pathway: "Pathway",
} as const

export const ChannelTypeEnum = {
  /**
   * Topic
   */
  Topic: "topic",
  /**
   * Department
   */
  Department: "department",
  /**
   * Unit
   */
  Unit: "unit",
  /**
   * Pathway
   */
  Pathway: "pathway",
} as const

export type ChannelTypeEnum =
  (typeof ChannelTypeEnum)[keyof typeof ChannelTypeEnum]

/**
 * Serializer for the ChannelOfferorDetail model
 */
export interface ChannelUnitDetail {
  unit: LearningResourceOfferorDetail
}
/**
 * Serializer for content feedback submissions.  ``user`` is set server-side from the request (never client-supplied). Each valid submission is persisted as a new append-only record.
 */
export interface ContentFeedback {
  course_id: string
  course_name?: string
  block_usage_key: string
  block_type?: string
  block_display_name?: string
  unit_title?: string
  url?: ContentFeedbackUrl
  sentiment: ContentFeedbackSentimentEnum
  comment?: string
}

/**
 * Serializer for content feedback submissions.  ``user`` is set server-side from the request (never client-supplied). Each valid submission is persisted as a new append-only record.
 */
export interface ContentFeedbackRequest {
  course_id: string
  course_name?: string
  block_usage_key: string
  block_type?: string
  block_display_name?: string
  unit_title?: string
  url?: ContentFeedbackUrl
  sentiment: ContentFeedbackSentimentEnum
  comment?: string
}

/**
 * * `positive` - Positive * `negative` - Negative * `idea` - Idea
 */

export const ContentFeedbackSentimentEnumDescriptions = {
  positive: "Positive",
  negative: "Negative",
  idea: "Idea",
} as const

export const ContentFeedbackSentimentEnum = {
  /**
   * Positive
   */
  Positive: "positive",
  /**
   * Negative
   */
  Negative: "negative",
  /**
   * Idea
   */
  Idea: "idea",
} as const

export type ContentFeedbackSentimentEnum =
  (typeof ContentFeedbackSentimentEnum)[keyof typeof ContentFeedbackSentimentEnum]

/**
 * @type ContentFeedbackUrl
 */
export type ContentFeedbackUrl = string

/**
 * Serializer class for course run ContentFiles
 */
export interface ContentFile {
  id: number
  run_id?: number
  direct_learning_resource_id?: number | null
  run_title?: string
  run_slug?: string
  departments: Array<LearningResourceDepartment>
  semester?: string
  year?: number
  topics: Array<LearningResourceTopic>
  key?: string | null
  uid?: string | null
  title?: string | null
  description?: string | null
  require_summaries: boolean
  url?: string | null
  content_feature_type: Array<string>
  content_type?: ContentFileContentTypeEnum
  content?: string | null
  content_title?: string | null
  content_author?: string | null
  content_language?: string | null
  checksum?: string
  image_src?: ContentFileImageSrc | null
  resource_id: string
  resource_readable_id: string
  source_path?: string
  /**
   * Extract the course number(s) from the associated course
   */
  course_number: Array<string>
  file_type?: string | null
  file_extension?: string | null
  offered_by: LearningResourceOfferor
  platform: LearningResourcePlatform
  run_readable_id?: string
  edx_module_id?: string | null
  summary?: string
  flashcards?: any
  youtube_id?: string | null
}

/**
 * * `page` - page * `file` - file * `video` - video * `pdf` - pdf
 */

export const ContentFileContentTypeEnumDescriptions = {
  page: "page",
  file: "file",
  video: "video",
  pdf: "pdf",
} as const

export const ContentFileContentTypeEnum = {
  /**
   * page
   */
  Page: "page",
  /**
   * file
   */
  File: "file",
  /**
   * video
   */
  Video: "video",
  /**
   * pdf
   */
  Pdf: "pdf",
} as const

export type ContentFileContentTypeEnum =
  (typeof ContentFileContentTypeEnum)[keyof typeof ContentFileContentTypeEnum]

/**
 * @type ContentFileImageSrc
 */
export type ContentFileImageSrc = string

/**
 * SearchResponseSerializer with OpenAPI annotations for Content Files search
 */
export interface ContentFileVectorSearchResponse {
  count: number
  next: string | null
  previous: string | null
  results: Array<ContentFile>
  metadata: ContentFileVectorSearchResponseMetadata
}
export interface ContentFileVectorSearchResponseMetadata {
  aggregations: {
    [
      key: string
    ]: Array<ContentFileVectorSearchResponseMetadataAggregationsValueInner>
  }
  suggestions: Array<string>
}
export interface ContentFileVectorSearchResponseMetadataAggregationsValueInner {
  key: string
  doc_count: number
}
export interface Counts {
  courses: number
  programs: number
}
/**
 * Serializer for the Course model
 */
export interface Course {
  course_numbers: Array<CourseNumber> | null
}
/**
 * Serializer for CourseNumber
 */
export interface CourseNumber {
  value: string
  department: LearningResourceDepartment
  listing_type: string
}
/**
 * Serializer for course resources
 */
export interface CourseResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: CourseResourceResourceTypeEnum
  course: Course
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: CourseResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const CourseResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type CourseResourceAvailabilityEnum =
  (typeof CourseResourceAvailabilityEnum)[keyof typeof CourseResourceAvailabilityEnum]

export interface CourseResourceCertificationType {
  code: CourseResourceCertificationTypeCodeEnum
  name: string
}

export const CourseResourceCertificationTypeCodeEnum = {
  Micromasters: "micromasters",
  Professional: "professional",
  Completion: "completion",
  None: "none",
} as const

export type CourseResourceCertificationTypeCodeEnum =
  (typeof CourseResourceCertificationTypeCodeEnum)[keyof typeof CourseResourceCertificationTypeCodeEnum]

export interface CourseResourceDeliveryInner {
  code: CourseResourceDeliveryInnerCodeEnum
  name: string
}

export const CourseResourceDeliveryInnerCodeEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const

export type CourseResourceDeliveryInnerCodeEnum =
  (typeof CourseResourceDeliveryInnerCodeEnum)[keyof typeof CourseResourceDeliveryInnerCodeEnum]

export interface CourseResourceFormatInner {
  code: CourseResourceFormatInnerCodeEnum
  name: string
}

export const CourseResourceFormatInnerCodeEnum = {
  Synchronous: "synchronous",
  Asynchronous: "asynchronous",
} as const

export type CourseResourceFormatInnerCodeEnum =
  (typeof CourseResourceFormatInnerCodeEnum)[keyof typeof CourseResourceFormatInnerCodeEnum]

export interface CourseResourcePaceInner {
  code: CourseResourcePaceInnerCodeEnum
  name: string
}

export const CourseResourcePaceInnerCodeEnum = {
  SelfPaced: "self_paced",
  InstructorPaced: "instructor_paced",
} as const

export type CourseResourcePaceInnerCodeEnum =
  (typeof CourseResourcePaceInnerCodeEnum)[keyof typeof CourseResourcePaceInnerCodeEnum]

export const CourseResourceResourceTypeEnumDescriptions = {
  course: "",
} as const

export const CourseResourceResourceTypeEnum = {
  Course: "course",
} as const

export type CourseResourceResourceTypeEnum =
  (typeof CourseResourceResourceTypeEnum)[keyof typeof CourseResourceResourceTypeEnum]

/**
 * Generated Open Badges credential metadata for a learning resource.
 */
export interface CredentialMetadata {
  resource_readable_id: string
  /**
   * The Open Badges 3.0 description, 1-2 sentences
   */
  description?: string
  /**
   * Open Badges 3.0 criteria, one skill-focused bullet per item, for rendering into the criteria narrative
   */
  criteria?: Array<string>
  /**
   * One entry per requested field that is missing above, saying why. Absent when every configured field was generated.
   */
  errors?: CredentialMetadataErrors
}
/**
 * Why a requested Open Badges field is missing from the response.
 */
export interface CredentialMetadataErrors {
  /**
   * Why no description was generated
   */
  description?: string
  /**
   * Why no criteria were generated
   */
  criteria?: string
}
/**
 * Request body for the credential metadata endpoint
 */
export interface CredentialMetadataRequestRequest {
  /**
   * The readable id of the learning resource to generate metadata for
   */
  resource_readable_id: string
}
/**
 * * `` - ---- * `Doctorate` - Doctorate * `Master\'s or professional degree` - Master\'s or professional degree * `Bachelor\'s degree` - Bachelor\'s degree * `Associate degree` - Associate degree * `Secondary/high school` - Secondary/high school * `Junior secondary/junior high/middle school` - Junior secondary/junior high/middle school * `No formal education` - No formal education * `Other education` - Other education
 */

export const CurrentEducationEnumDescriptions = {
  Doctorate: "Doctorate",
  "Master's or professional degree": "Master's or professional degree",
  "Bachelor's degree": "Bachelor's degree",
  "Associate degree": "Associate degree",
  "Secondary/high school": "Secondary/high school",
  "Junior secondary/junior high/middle school":
    "Junior secondary/junior high/middle school",
  "No formal education": "No formal education",
  "Other education": "Other education",
} as const

export const CurrentEducationEnum = {
  /**
   * Doctorate
   */
  Doctorate: "Doctorate",
  /**
   * Master&#39;s or professional degree
   */
  MastersOrProfessionalDegree: "Master's or professional degree",
  /**
   * Bachelor&#39;s degree
   */
  BachelorsDegree: "Bachelor's degree",
  /**
   * Associate degree
   */
  AssociateDegree: "Associate degree",
  /**
   * Secondary/high school
   */
  SecondaryHighSchool: "Secondary/high school",
  /**
   * Junior secondary/junior high/middle school
   */
  JuniorSecondaryJuniorHighMiddleSchool:
    "Junior secondary/junior high/middle school",
  /**
   * No formal education
   */
  NoFormalEducation: "No formal education",
  /**
   * Other education
   */
  OtherEducation: "Other education",
} as const

export type CurrentEducationEnum =
  (typeof CurrentEducationEnum)[keyof typeof CurrentEducationEnum]

/**
 * Serializer for the requesting user.  Unlike UserSerializer this exposes the user\'s own email plus whether they can manage their credentials, both of which the settings page needs. It is read-only: users change their email through Keycloak, not through us.
 */
export interface CurrentUser {
  id: number
  username: string
  global_id: string | null
  profile?: Profile
  email: string
  first_name: string
  last_name: string
  is_article_editor: boolean
  is_learning_path_editor: boolean
  is_authenticated: boolean
  /**
   * Whether the user signs in through an external identity provider, and so cannot change their email or password through us.
   */
  is_sso_user: boolean
}
/**
 * * `online` - Online * `hybrid` - Hybrid * `in_person` - In-Person * `offline` - Offline
 */

export const DeliveryEnumDescriptions = {
  online: "Online",
  hybrid: "Hybrid",
  in_person: "In-Person",
  offline: "Offline",
} as const

export const DeliveryEnum = {
  /**
   * Online
   */
  Online: "online",
  /**
   * Hybrid
   */
  Hybrid: "hybrid",
  /**
   * In-Person
   */
  InPerson: "in_person",
  /**
   * Offline
   */
  Offline: "offline",
} as const

export type DeliveryEnum = (typeof DeliveryEnum)[keyof typeof DeliveryEnum]

/**
 * Serializer for Channel model of type department
 */
export interface DepartmentChannel {
  id: number
  /**
   * Get the avatar image URL
   */
  avatar: string | null
  /**
   * Get the avatar image small URL
   */
  avatar_small: string | null
  /**
   * Get the avatar image medium URL
   */
  avatar_medium: string | null
  /**
   * Get the banner image URL
   */
  banner: string | null
  lists: Array<LearningPathPreview>
  /**
   * Get the URL for the channel
   */
  channel_url: string
  /**
   * Learning path featured in this channel.
   */
  featured_list: LearningPathPreview | null
  sub_channels: Array<SubChannel>
  channel_type: DepartmentChannelTypeEnum
  department_detail: ChannelDepartmentDetail
  created_on: string
  updated_on: string
  name: string
  title: string
  about?: any | null
  configuration?: any | null
  search_filter?: string
  public_description?: string
  ga_tracking_id?: string
  widget_list?: number | null
}

/**
 * * `department` - Department
 */

export const DepartmentChannelTypeEnumDescriptions = {
  department: "Department",
} as const

export const DepartmentChannelTypeEnum = {
  /**
   * Department
   */
  Department: "department",
} as const

export type DepartmentChannelTypeEnum =
  (typeof DepartmentChannelTypeEnum)[keyof typeof DepartmentChannelTypeEnum]

/**
 * Serializer for document resources
 */
export interface DocumentResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: DocumentResourceResourceTypeEnum
  content_files: Array<NestedContentFile> | null
  description: string | null
  readable_id: string
  title: string
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: DocumentResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const DocumentResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type DocumentResourceAvailabilityEnum =
  (typeof DocumentResourceAvailabilityEnum)[keyof typeof DocumentResourceAvailabilityEnum]

export const DocumentResourceResourceTypeEnumDescriptions = {
  document: "",
} as const

export const DocumentResourceResourceTypeEnum = {
  Document: "document",
} as const

export type DocumentResourceResourceTypeEnum =
  (typeof DocumentResourceResourceTypeEnum)[keyof typeof DocumentResourceResourceTypeEnum]

/**
 * Serializer for News FeedItem
 */
export interface EventFeedItem {
  id: number
  feed_type: EventFeedItemFeedTypeEnum
  image: FeedImage
  event_details: FeedEventDetail
  guid: string
  title: string
  url: string
  summary?: string
  content?: string
  source: number
}

export const EventFeedItemFeedTypeEnumDescriptions = {
  events: "",
} as const

export const EventFeedItemFeedTypeEnum = {
  Events: "events",
} as const

export type EventFeedItemFeedTypeEnum =
  (typeof EventFeedItemFeedTypeEnum)[keyof typeof EventFeedItemFeedTypeEnum]

/**
 * FeedEventDetail serializer
 */
export interface FeedEventDetail {
  id: number
  audience: Array<string>
  location: Array<string>
  event_type: Array<string>
  event_datetime: string
  event_end_datetime?: string | null
}
/**
 * Serializer for FeedImage
 */
export interface FeedImage {
  id: number
  url?: string
  description?: string
  alt?: string
}
/**
 * @type FeedItem
 */
export type FeedItem =
  | ({ resource_type: "events" } & EventFeedItem)
  | ({ resource_type: "news" } & NewsFeedItem)

/**
 * FeedNewsDetail serializer
 */
export interface FeedNewsDetail {
  id: number
  authors?: Array<string>
  topics?: Array<string>
  publish_date: string
}
/**
 * FeedSource serializer
 */
export interface FeedSource {
  id: number
  image: FeedImage
  title: string
  url: string
  description?: string
  feed_type: FeedSourceFeedTypeEnum
}

/**
 * * `news` - News * `events` - Events
 */

export const FeedSourceFeedTypeEnumDescriptions = {
  news: "News",
  events: "Events",
} as const

export const FeedSourceFeedTypeEnum = {
  /**
   * News
   */
  News: "news",
  /**
   * Events
   */
  Events: "events",
} as const

export type FeedSourceFeedTypeEnum =
  (typeof FeedSourceFeedTypeEnum)[keyof typeof FeedSourceFeedTypeEnum]

/**
 * * `academic-excellence` - Academic Boost * `career-growth` - Career Growth * `lifelong-learning` - Lifelong Learning
 */

export const GoalsEnumDescriptions = {
  "academic-excellence": "Academic Boost",
  "career-growth": "Career Growth",
  "lifelong-learning": "Lifelong Learning",
} as const

export const GoalsEnum = {
  /**
   * Academic Boost
   */
  AcademicExcellence: "academic-excellence",
  /**
   * Career Growth
   */
  CareerGrowth: "career-growth",
  /**
   * Lifelong Learning
   */
  LifelongLearning: "lifelong-learning",
} as const

export type GoalsEnum = (typeof GoalsEnum)[keyof typeof GoalsEnum]

/**
 * Serializer for the LearningPath model
 */
export interface LearningPath {
  id: number
  /**
   * Number of published items in the list.
   */
  item_count: number
}
/**
 * Serializer for a minimal preview of Learning Paths
 */
export interface LearningPathPreview {
  title: string
  url?: string | null
  id: number
}
/**
 * CRUD serializer for LearningPath resources
 */
export interface LearningPathResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: LearningPathResourceResourceTypeEnum
  /**
   * The display category for this resource.
   */
  resource_category: string
  learning_path: LearningPath
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: LearningPathResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const LearningPathResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type LearningPathResourceAvailabilityEnum =
  (typeof LearningPathResourceAvailabilityEnum)[keyof typeof LearningPathResourceAvailabilityEnum]

export const LearningPathResourceResourceTypeEnumDescriptions = {
  learning_path: "",
} as const

export const LearningPathResourceResourceTypeEnum = {
  LearningPath: "learning_path",
} as const

export type LearningPathResourceResourceTypeEnum =
  (typeof LearningPathResourceResourceTypeEnum)[keyof typeof LearningPathResourceResourceTypeEnum]

/**
 * @type LearningResource
 */
export type LearningResource =
  | ({ resource_type: "course" } & CourseResource)
  | ({ resource_type: "document" } & DocumentResource)
  | ({ resource_type: "learning_path" } & LearningPathResource)
  | ({ resource_type: "podcast" } & PodcastResource)
  | ({ resource_type: "podcast_episode" } & PodcastEpisodeResource)
  | ({ resource_type: "program" } & ProgramResource)
  | ({ resource_type: "video" } & VideoResource)
  | ({ resource_type: "video_playlist" } & VideoPlaylistResource)

/**
 * Base serializer for LearningResourceSchool model, minus departments list  The absence of the departments list is to avoid a circular serialization structure.
 */
export interface LearningResourceBaseSchool {
  id: number
  name: string
  url: string
}
/**
 * Full serializer for LearningResourceDepartment, including school
 */
export interface LearningResourceDepartment {
  department_id: string
  name: string
  channel_url: string | null
  school: LearningResourceBaseSchool | null
}
/**
 * Serializer for LearningResourceImage
 */
export interface LearningResourceImage {
  id: number
  url: string
  description?: string | null
  alt?: string | null
}
/**
 * Serializer for LearningResourceInstructor model
 */
export interface LearningResourceInstructor {
  id: number
  first_name?: string | null
  last_name?: string | null
  full_name?: string | null
}
/**
 * Serializer for LearningResourceOfferor with basic details
 */
export interface LearningResourceOfferor {
  code: string
  name: string
  channel_url: string | null
  display_facet?: boolean
}
/**
 * Serializer for LearningResourceOfferor with all details
 */
export interface LearningResourceOfferorDetail {
  code: string
  channel_url: string | null
  name: string
  professional?: boolean
  offerings?: Array<string>
  audience?: Array<string>
  formats?: Array<string>
  fee?: Array<string>
  certifications?: Array<string>
  content_types?: Array<string>
  more_information?: LearningResourceOfferorDetailMoreInformation
  value_prop?: string
  display_facet?: boolean
}
/**
 * @type LearningResourceOfferorDetailMoreInformation
 */
export type LearningResourceOfferorDetailMoreInformation = string

/**
 * Serializer for LearningResourcePlatform
 */
export interface LearningResourcePlatform {
  code: string
  name?: string
}
/**
 * Serializer for LearningResourcePrice model
 */
export interface LearningResourcePrice {
  amount: string
  currency: string
}
/**
 * Serializer field for the LearningResourceRelationship model that uses the LearningResourceSerializer to serialize the child resources
 */
export interface LearningResourceRelationshipChildField {
  child: number
  position?: number
  relation_type?: RelationTypeEnum
  title: string
  readable_id: string
}

/**
 * Serializer for the LearningResourceRun model
 */
export interface LearningResourceRun {
  id: number
  instructors: Array<LearningResourceInstructor> | null
  image: LearningResourceImage | null
  level: Array<LearningResourceRunLevelInner>
  delivery: Array<CourseResourceDeliveryInner>
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  resource_prices: Array<LearningResourcePrice>
  run_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  slug?: string | null
  semester?: string | null
  year?: number | null
  start_date?: string | null
  end_date?: string | null
  enrollment_start?: string | null
  enrollment_end?: string | null
  prices?: Array<string> | null
  checksum?: string | null
  availability?: LearningResourceRunAvailabilityEnum | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
}

export const LearningResourceRunAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type LearningResourceRunAvailabilityEnum =
  (typeof LearningResourceRunAvailabilityEnum)[keyof typeof LearningResourceRunAvailabilityEnum]

export interface LearningResourceRunLevelInner {
  code: LearningResourceRunLevelInnerCodeEnum
  name: string
}

export const LearningResourceRunLevelInnerCodeEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const

export type LearningResourceRunLevelInnerCodeEnum =
  (typeof LearningResourceRunLevelInnerCodeEnum)[keyof typeof LearningResourceRunLevelInnerCodeEnum]

/**
 * Serializer for LearningResourceTopic model
 */
export interface LearningResourceTopic {
  id: number
  name: string
  /**
   * The icon to display for the topic.
   */
  icon?: string
  parent?: number | null
  channel_url: string | null
}
/**
 * Response serializer for vector based search
 */
export interface LearningResourcesVectorSearchResponse {
  count: number
  next: string | null
  previous: string | null
  results: Array<LearningResource>
  metadata: ContentFileVectorSearchResponseMetadata
}
/**
 * ContentFileSerializer without the large text fields (content, summary, flashcards), for nesting inside learning resource API responses. The search indexing path re-adds full content where needed.
 */
export interface NestedContentFile {
  id: number
  run_id?: number
  direct_learning_resource_id?: number | null
  run_title?: string
  run_slug?: string
  departments: Array<LearningResourceDepartment>
  semester?: string
  year?: number
  topics: Array<LearningResourceTopic>
  key?: string | null
  uid?: string | null
  title?: string | null
  description?: string | null
  require_summaries: boolean
  url?: string | null
  content_feature_type: Array<string>
  content_type?: ContentFileContentTypeEnum
  content_title?: string | null
  content_author?: string | null
  content_language?: string | null
  checksum?: string
  image_src?: ContentFileImageSrc | null
  resource_id: string
  resource_readable_id: string
  source_path?: string
  /**
   * Extract the course number(s) from the associated course
   */
  course_number: Array<string>
  file_type?: string | null
  file_extension?: string | null
  offered_by: LearningResourceOfferor
  platform: LearningResourcePlatform
  run_readable_id?: string
  edx_module_id?: string | null
  youtube_id?: string | null
}

/**
 * Serializer for News FeedItem
 */
export interface NewsFeedItem {
  id: number
  feed_type: NewsFeedItemFeedTypeEnum
  image: FeedImage
  news_details: FeedNewsDetail
  guid: string
  title: string
  url: string
  summary?: string
  content?: string
  source: number
}

export const NewsFeedItemFeedTypeEnumDescriptions = {
  news: "",
} as const

export const NewsFeedItemFeedTypeEnum = {
  News: "news",
} as const

export type NewsFeedItemFeedTypeEnum =
  (typeof NewsFeedItemFeedTypeEnum)[keyof typeof NewsFeedItemFeedTypeEnum]

export const NullEnumDescriptions = {} as const

export const NullEnum = {} as const

export type NullEnum = (typeof NullEnum)[keyof typeof NullEnum]

export interface PaginatedAttestationList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Attestation>
}
export interface PaginatedChannelList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<Channel>
}
export interface PaginatedFeedItemList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<FeedItem>
}
export interface PaginatedFeedSourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<FeedSource>
}
export interface PaginatedLearningResourceList {
  count: number
  next?: string | null
  previous?: string | null
  results: Array<LearningResource>
}
/**
 * Serializer for Profile
 */
export interface PatchedProfileRequest {
  image?: string | null
  image_small?: string | null
  image_medium?: string | null
  email_optin?: boolean | null
  toc_optin?: boolean
  bio?: string | null
  headline?: string | null
  location?: any | null
  topic_interests?: Array<number>
  goals?: Array<GoalsEnum>
  current_education?: PatchedProfileRequestCurrentEducationEnum
  certificate_desired?: PatchedProfileRequestCertificateDesiredEnum
  time_commitment?: PatchedProfileRequestTimeCommitmentEnum
  delivery?: Array<DeliveryEnum>
}

export const PatchedProfileRequestCurrentEducationEnum = {
  Doctorate: "Doctorate",
  MastersOrProfessionalDegree: "Master's or professional degree",
  BachelorsDegree: "Bachelor's degree",
  AssociateDegree: "Associate degree",
  SecondaryHighSchool: "Secondary/high school",
  JuniorSecondaryJuniorHighMiddleSchool:
    "Junior secondary/junior high/middle school",
  NoFormalEducation: "No formal education",
  OtherEducation: "Other education",
  Empty: "",
} as const

export type PatchedProfileRequestCurrentEducationEnum =
  (typeof PatchedProfileRequestCurrentEducationEnum)[keyof typeof PatchedProfileRequestCurrentEducationEnum]
export const PatchedProfileRequestCertificateDesiredEnum = {
  Yes: "yes",
  No: "no",
  NotSureYet: "not-sure-yet",
  Empty: "",
} as const

export type PatchedProfileRequestCertificateDesiredEnum =
  (typeof PatchedProfileRequestCertificateDesiredEnum)[keyof typeof PatchedProfileRequestCertificateDesiredEnum]
export const PatchedProfileRequestTimeCommitmentEnum = {
  _0To5Hours: "0-to-5-hours",
  _5To10Hours: "5-to-10-hours",
  _10To20Hours: "10-to-20-hours",
  _20To30Hours: "20-to-30-hours",
  _30PlusHours: "30-plus-hours",
  Empty: "",
} as const

export type PatchedProfileRequestTimeCommitmentEnum =
  (typeof PatchedProfileRequestTimeCommitmentEnum)[keyof typeof PatchedProfileRequestTimeCommitmentEnum]

/**
 * Serializer for User
 */
export interface PatchedUserRequest {
  profile?: ProfileRequest
  email?: string
}
/**
 * Serializer for WidgetLists
 */
export interface PatchedWidgetListRequest {
  widgets?: Array<WidgetInstance> | null
}
/**
 * Serializer for Channel model of type pathway
 */
export interface PathwayChannel {
  id: number
  /**
   * Get the avatar image URL
   */
  avatar: string | null
  /**
   * Get the avatar image small URL
   */
  avatar_small: string | null
  /**
   * Get the avatar image medium URL
   */
  avatar_medium: string | null
  /**
   * Get the banner image URL
   */
  banner: string | null
  lists: Array<LearningPathPreview>
  /**
   * Get the URL for the channel
   */
  channel_url: string
  /**
   * Learning path featured in this channel.
   */
  featured_list: LearningPathPreview | null
  sub_channels: Array<SubChannel>
  channel_type: PathwayChannelTypeEnum
  created_on: string
  updated_on: string
  name: string
  title: string
  about?: any | null
  configuration?: any | null
  search_filter?: string
  public_description?: string
  ga_tracking_id?: string
  widget_list?: number | null
}

/**
 * * `pathway` - Pathway
 */

export const PathwayChannelTypeEnumDescriptions = {
  pathway: "Pathway",
} as const

export const PathwayChannelTypeEnum = {
  /**
   * Pathway
   */
  Pathway: "pathway",
} as const

export type PathwayChannelTypeEnum =
  (typeof PathwayChannelTypeEnum)[keyof typeof PathwayChannelTypeEnum]

/**
 * Serializer for Podcasts
 */
export interface Podcast {
  id: number
  episode_count: number
  apple_podcasts_url?: string | null
  google_podcasts_url?: string | null
  rss_url?: string | null
}
/**
 * Serializer for PodcastEpisode
 */
export interface PodcastEpisode {
  id: number
  /**
   * Get the podcast id(s) the episode belongs to
   */
  podcasts: Array<number>
  parent_podcasts: Array<PodcastEpisodeParent>
  /**
   * Whether a transcript is available from the transcript endpoint.  The text itself is excluded from this serializer, so this is how a client knows whether to fetch it.
   */
  has_transcript: boolean
  audio_url: string
  episode_link?: string | null
  duration?: string | null
}
/**
 * Minimal parent-podcast summary embedded in an episode.
 */
export interface PodcastEpisodeParent {
  id: number
  title: string
  readable_id: string
  /**
   * Where this podcast lives within Learn
   */
  learn_url: string
}
/**
 * Serializer for podcast episode resources
 */
export interface PodcastEpisodeResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: PodcastEpisodeResourceResourceTypeEnum
  podcast_episode: PodcastEpisode
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: PodcastEpisodeResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const PodcastEpisodeResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type PodcastEpisodeResourceAvailabilityEnum =
  (typeof PodcastEpisodeResourceAvailabilityEnum)[keyof typeof PodcastEpisodeResourceAvailabilityEnum]

export const PodcastEpisodeResourceResourceTypeEnumDescriptions = {
  podcast_episode: "",
} as const

export const PodcastEpisodeResourceResourceTypeEnum = {
  PodcastEpisode: "podcast_episode",
} as const

export type PodcastEpisodeResourceResourceTypeEnum =
  (typeof PodcastEpisodeResourceResourceTypeEnum)[keyof typeof PodcastEpisodeResourceResourceTypeEnum]

/**
 * Serializer for podcast resources
 */
export interface PodcastResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: PodcastResourceResourceTypeEnum
  podcast: Podcast
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: PodcastResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const PodcastResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type PodcastResourceAvailabilityEnum =
  (typeof PodcastResourceAvailabilityEnum)[keyof typeof PodcastResourceAvailabilityEnum]

export const PodcastResourceResourceTypeEnumDescriptions = {
  podcast: "",
} as const

export const PodcastResourceResourceTypeEnum = {
  Podcast: "podcast",
} as const

export type PodcastResourceResourceTypeEnum =
  (typeof PodcastResourceResourceTypeEnum)[keyof typeof PodcastResourceResourceTypeEnum]

/**
 * Serializer for profile search preference filters
 */
export interface PreferencesSearch {
  certification?: boolean
  topic?: Array<string>
  delivery?: Array<string>
}
export interface ProblemListResponse {
  problem_set_titles: Array<string>
}
/**
 * Serializer for Profile
 */
export interface Profile {
  /**
   * Get the user\'s name
   */
  name: string
  image?: string | null
  image_small?: string | null
  image_medium?: string | null
  image_file: string | null
  image_small_file: string | null
  image_medium_file: string | null
  /**
   * Custom getter for small profile image
   */
  profile_image_small: string
  /**
   * Custom getter for medium profile image
   */
  profile_image_medium: string
  email_optin?: boolean | null
  bio?: string | null
  headline?: string | null
  /**
   * Custom getter for the username
   */
  username: string
  /**
   * Custom getter for location text
   */
  placename: string
  topic_interests?: Array<LearningResourceTopic>
  goals?: Array<GoalsEnum>
  current_education?: ProfileCurrentEducationEnum
  certificate_desired?: ProfileCertificateDesiredEnum
  time_commitment?: ProfileTimeCommitmentEnum
  delivery?: Array<DeliveryEnum>
  preference_search_filters: PreferencesSearch
}

export const ProfileCurrentEducationEnum = {
  Doctorate: "Doctorate",
  MastersOrProfessionalDegree: "Master's or professional degree",
  BachelorsDegree: "Bachelor's degree",
  AssociateDegree: "Associate degree",
  SecondaryHighSchool: "Secondary/high school",
  JuniorSecondaryJuniorHighMiddleSchool:
    "Junior secondary/junior high/middle school",
  NoFormalEducation: "No formal education",
  OtherEducation: "Other education",
  Empty: "",
} as const

export type ProfileCurrentEducationEnum =
  (typeof ProfileCurrentEducationEnum)[keyof typeof ProfileCurrentEducationEnum]
export const ProfileCertificateDesiredEnum = {
  Yes: "yes",
  No: "no",
  NotSureYet: "not-sure-yet",
  Empty: "",
} as const

export type ProfileCertificateDesiredEnum =
  (typeof ProfileCertificateDesiredEnum)[keyof typeof ProfileCertificateDesiredEnum]
export const ProfileTimeCommitmentEnum = {
  _0To5Hours: "0-to-5-hours",
  _5To10Hours: "5-to-10-hours",
  _10To20Hours: "10-to-20-hours",
  _20To30Hours: "20-to-30-hours",
  _30PlusHours: "30-plus-hours",
  Empty: "",
} as const

export type ProfileTimeCommitmentEnum =
  (typeof ProfileTimeCommitmentEnum)[keyof typeof ProfileTimeCommitmentEnum]

/**
 * Serializer for Profile
 */
export interface ProfileRequest {
  image?: string | null
  image_small?: string | null
  image_medium?: string | null
  email_optin?: boolean | null
  toc_optin?: boolean
  bio?: string | null
  headline?: string | null
  location?: any | null
  topic_interests?: Array<number>
  goals?: Array<GoalsEnum>
  current_education?: ProfileRequestCurrentEducationEnum
  certificate_desired?: ProfileRequestCertificateDesiredEnum
  time_commitment?: ProfileRequestTimeCommitmentEnum
  delivery?: Array<DeliveryEnum>
}

export const ProfileRequestCurrentEducationEnum = {
  Doctorate: "Doctorate",
  MastersOrProfessionalDegree: "Master's or professional degree",
  BachelorsDegree: "Bachelor's degree",
  AssociateDegree: "Associate degree",
  SecondaryHighSchool: "Secondary/high school",
  JuniorSecondaryJuniorHighMiddleSchool:
    "Junior secondary/junior high/middle school",
  NoFormalEducation: "No formal education",
  OtherEducation: "Other education",
  Empty: "",
} as const

export type ProfileRequestCurrentEducationEnum =
  (typeof ProfileRequestCurrentEducationEnum)[keyof typeof ProfileRequestCurrentEducationEnum]
export const ProfileRequestCertificateDesiredEnum = {
  Yes: "yes",
  No: "no",
  NotSureYet: "not-sure-yet",
  Empty: "",
} as const

export type ProfileRequestCertificateDesiredEnum =
  (typeof ProfileRequestCertificateDesiredEnum)[keyof typeof ProfileRequestCertificateDesiredEnum]
export const ProfileRequestTimeCommitmentEnum = {
  _0To5Hours: "0-to-5-hours",
  _5To10Hours: "5-to-10-hours",
  _10To20Hours: "10-to-20-hours",
  _20To30Hours: "20-to-30-hours",
  _30PlusHours: "30-plus-hours",
  Empty: "",
} as const

export type ProfileRequestTimeCommitmentEnum =
  (typeof ProfileRequestTimeCommitmentEnum)[keyof typeof ProfileRequestTimeCommitmentEnum]

/**
 * Serializer for the Program model
 */
export interface Program {
  course_count: number
  program_count: number
}
/**
 * Serializer for Program Certificates
 */
export interface ProgramCertificate {
  record_hash: string
  program_letter_generate_url: string
  program_letter_share_url: string
  program_title: string
  user_full_name?: string
  user_email: string
  user_edxorg_id?: number | null
  micromasters_program_id?: number | null
  mitxonline_program_id?: number | null
  user_edxorg_username?: string | null
  user_gender?: string | null
  user_address_city?: string | null
  user_first_name?: string | null
  user_last_name?: string | null
  user_year_of_birth?: string | null
  user_country?: string | null
  user_address_postal_code?: string | null
  user_street_address?: string | null
  user_address_state_or_territory?: string | null
  user_mitxonline_username?: string | null
  program_completion_timestamp?: string | null
}
/**
 * Serializer for program resources
 */
export interface ProgramResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: ProgramResourceResourceTypeEnum
  program: Program
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: ProgramResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const ProgramResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type ProgramResourceAvailabilityEnum =
  (typeof ProgramResourceAvailabilityEnum)[keyof typeof ProgramResourceAvailabilityEnum]

export const ProgramResourceResourceTypeEnumDescriptions = {
  program: "",
} as const

export const ProgramResourceResourceTypeEnum = {
  Program: "program",
} as const

export type ProgramResourceResourceTypeEnum =
  (typeof ProgramResourceResourceTypeEnum)[keyof typeof ProgramResourceResourceTypeEnum]

/**
 * * `PROGRAM_COURSES` - Program Courses * `PROGRAM_PROGRAMS` - Program Programs * `LEARNING_PATH_ITEMS` - Learning Path Items * `PODCAST_EPISODES` - Podcast Episodes * `PLAYLIST_VIDEOS` - Playlist Videos * `COURSE_LEARNING_MATERIALS` - Course Learning Materials
 */

export const RelationTypeEnumDescriptions = {
  PROGRAM_COURSES: "Program Courses",
  PROGRAM_PROGRAMS: "Program Programs",
  LEARNING_PATH_ITEMS: "Learning Path Items",
  PODCAST_EPISODES: "Podcast Episodes",
  PLAYLIST_VIDEOS: "Playlist Videos",
  COURSE_LEARNING_MATERIALS: "Course Learning Materials",
} as const

export const RelationTypeEnum = {
  /**
   * Program Courses
   */
  ProgramCourses: "PROGRAM_COURSES",
  /**
   * Program Programs
   */
  ProgramPrograms: "PROGRAM_PROGRAMS",
  /**
   * Learning Path Items
   */
  LearningPathItems: "LEARNING_PATH_ITEMS",
  /**
   * Podcast Episodes
   */
  PodcastEpisodes: "PODCAST_EPISODES",
  /**
   * Playlist Videos
   */
  PlaylistVideos: "PLAYLIST_VIDEOS",
  /**
   * Course Learning Materials
   */
  CourseLearningMaterials: "COURSE_LEARNING_MATERIALS",
} as const

export type RelationTypeEnum =
  (typeof RelationTypeEnum)[keyof typeof RelationTypeEnum]

/**
 * * `course` - course * `program` - program * `learning_path` - learning_path * `podcast` - podcast * `podcast_episode` - podcast_episode * `video` - video * `video_playlist` - video_playlist * `document` - document
 */

export const ResourceTypeEnumDescriptions = {
  course: "course",
  program: "program",
  learning_path: "learning_path",
  podcast: "podcast",
  podcast_episode: "podcast_episode",
  video: "video",
  video_playlist: "video_playlist",
  document: "document",
} as const

export const ResourceTypeEnum = {
  /**
   * course
   */
  Course: "course",
  /**
   * program
   */
  Program: "program",
  /**
   * learning_path
   */
  LearningPath: "learning_path",
  /**
   * podcast
   */
  Podcast: "podcast",
  /**
   * podcast_episode
   */
  PodcastEpisode: "podcast_episode",
  /**
   * video
   */
  Video: "video",
  /**
   * video_playlist
   */
  VideoPlaylist: "video_playlist",
  /**
   * document
   */
  Document: "document",
} as const

export type ResourceTypeEnum =
  (typeof ResourceTypeEnum)[keyof typeof ResourceTypeEnum]

/**
 * * `course` - Course * `program` - Program * `learning_material` - Learning Material
 */

export const ResourceTypeGroupEnumDescriptions = {
  course: "Course",
  program: "Program",
  learning_material: "Learning Material",
} as const

export const ResourceTypeGroupEnum = {
  /**
   * Course
   */
  Course: "course",
  /**
   * Program
   */
  Program: "program",
  /**
   * Learning Material
   */
  LearningMaterial: "learning_material",
} as const

export type ResourceTypeGroupEnum =
  (typeof ResourceTypeGroupEnum)[keyof typeof ResourceTypeGroupEnum]

export interface RetrieveProblemResponse {
  problem_set: string
  solution_set: string
}
/**
 * Serializer for SubChannels
 */
export interface SubChannel {
  parent_channel: string
  channel: string
  position?: number
}
/**
 * * `0-to-5-hours` - <5 hours/week * `5-to-10-hours` - 5-10 hours/week * `10-to-20-hours` - 10-20 hours/week * `20-to-30-hours` - 20-30 hours/week * `30-plus-hours` - 30+ hours/week
 */

export const TimeCommitmentEnumDescriptions = {
  "0-to-5-hours": "<5 hours/week",
  "5-to-10-hours": "5-10 hours/week",
  "10-to-20-hours": "10-20 hours/week",
  "20-to-30-hours": "20-30 hours/week",
  "30-plus-hours": "30+ hours/week",
} as const

export const TimeCommitmentEnum = {
  /**
   * &lt;5 hours/week
   */
  _0To5Hours: "0-to-5-hours",
  /**
   * 5-10 hours/week
   */
  _5To10Hours: "5-to-10-hours",
  /**
   * 10-20 hours/week
   */
  _10To20Hours: "10-to-20-hours",
  /**
   * 20-30 hours/week
   */
  _20To30Hours: "20-to-30-hours",
  /**
   * 30+ hours/week
   */
  _30PlusHours: "30-plus-hours",
} as const

export type TimeCommitmentEnum =
  (typeof TimeCommitmentEnum)[keyof typeof TimeCommitmentEnum]

/**
 * Serializer for Channel model of type topic
 */
export interface TopicChannel {
  id: number
  /**
   * Get the avatar image URL
   */
  avatar: string | null
  /**
   * Get the avatar image small URL
   */
  avatar_small: string | null
  /**
   * Get the avatar image medium URL
   */
  avatar_medium: string | null
  /**
   * Get the banner image URL
   */
  banner: string | null
  lists: Array<LearningPathPreview>
  /**
   * Get the URL for the channel
   */
  channel_url: string
  /**
   * Learning path featured in this channel.
   */
  featured_list: LearningPathPreview | null
  sub_channels: Array<SubChannel>
  channel_type: TopicChannelTypeEnum
  topic_detail: ChannelTopicDetail
  created_on: string
  updated_on: string
  name: string
  title: string
  about?: any | null
  configuration?: any | null
  search_filter?: string
  public_description?: string
  ga_tracking_id?: string
  widget_list?: number | null
}

/**
 * * `topic` - Topic
 */

export const TopicChannelTypeEnumDescriptions = {
  topic: "Topic",
} as const

export const TopicChannelTypeEnum = {
  /**
   * Topic
   */
  Topic: "topic",
} as const

export type TopicChannelTypeEnum =
  (typeof TopicChannelTypeEnum)[keyof typeof TopicChannelTypeEnum]

/**
 * Serializer for Channel model of type unit
 */
export interface UnitChannel {
  id: number
  /**
   * Get the avatar image URL
   */
  avatar: string | null
  /**
   * Get the avatar image small URL
   */
  avatar_small: string | null
  /**
   * Get the avatar image medium URL
   */
  avatar_medium: string | null
  /**
   * Get the banner image URL
   */
  banner: string | null
  lists: Array<LearningPathPreview>
  /**
   * Get the URL for the channel
   */
  channel_url: string
  /**
   * Learning path featured in this channel.
   */
  featured_list: LearningPathPreview | null
  sub_channels: Array<SubChannel>
  channel_type: UnitChannelTypeEnum
  unit_detail: ChannelUnitDetail
  created_on: string
  updated_on: string
  name: string
  title: string
  about?: any | null
  configuration?: any | null
  search_filter?: string
  public_description?: string
  ga_tracking_id?: string
  widget_list?: number | null
}

/**
 * * `unit` - Unit
 */

export const UnitChannelTypeEnumDescriptions = {
  unit: "Unit",
} as const

export const UnitChannelTypeEnum = {
  /**
   * Unit
   */
  Unit: "unit",
} as const

export type UnitChannelTypeEnum =
  (typeof UnitChannelTypeEnum)[keyof typeof UnitChannelTypeEnum]

/**
 * Serializer for User
 */
export interface User {
  id: number
  username: string
  global_id: string | null
  profile?: Profile
  first_name: string
  last_name: string
  is_article_editor: boolean
  is_learning_path_editor: boolean
  is_authenticated: boolean
}
/**
 * Serializer for User
 */
export interface UserRequest {
  profile?: ProfileRequest
  email: string
}
/**
 * Serializer for the Video model
 */
export interface Video {
  id: number
  caption_urls: Array<CaptionUrl>
  streaming_url: VideoStreamingUrl | null
  cover_image_url: VideoStreamingUrl | null
  duration: string
}
/**
 * Serializer for the VideoChannel model
 */
export interface VideoChannel {
  channel_id: string
  title: string
}
/**
 * Serializer for the VideoPlaylist model
 */
export interface VideoPlaylist {
  id: number
  channel: VideoChannel | null
  video_count: number
  parent_learning_resource_id: number | null
  parent_title: string | null
  parent_url: string | null
  /**
   * Extract the course number(s) from the parent course, if any
   */
  parent_course_numbers: Array<string>
}
/**
 * Serializer for video playlist resources
 */
export interface VideoPlaylistResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: VideoPlaylistResourceResourceTypeEnum
  video_playlist: VideoPlaylist
  readable_id: string
  title: string
  description?: string | null
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: VideoPlaylistResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const VideoPlaylistResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type VideoPlaylistResourceAvailabilityEnum =
  (typeof VideoPlaylistResourceAvailabilityEnum)[keyof typeof VideoPlaylistResourceAvailabilityEnum]

export const VideoPlaylistResourceResourceTypeEnumDescriptions = {
  video_playlist: "",
} as const

export const VideoPlaylistResourceResourceTypeEnum = {
  VideoPlaylist: "video_playlist",
} as const

export type VideoPlaylistResourceResourceTypeEnum =
  (typeof VideoPlaylistResourceResourceTypeEnum)[keyof typeof VideoPlaylistResourceResourceTypeEnum]

/**
 * Serializer for video resources
 */
export interface VideoResource {
  id: number
  topics?: Array<LearningResourceTopic>
  position: number | null
  offered_by: LearningResourceOfferor | null
  platform: LearningResourcePlatform | null
  course_feature: Array<string> | null
  departments: Array<LearningResourceDepartment> | null
  certification: boolean
  certification_type: CourseResourceCertificationType
  prices: Array<string>
  resource_prices: Array<LearningResourcePrice>
  runs: Array<LearningResourceRun> | null
  image: LearningResourceImage | null
  views: number
  delivery: Array<CourseResourceDeliveryInner>
  /**
   * Return true if the resource is free/has a free option
   */
  free: boolean
  /**
   * The resource type group for UI grouping.  For courses/programs, this is derived from resource_category (which may differ from resource_type). For all other types, returns \"learning_material\".  * `course` - Course * `program` - Program * `learning_material` - Learning Material
   */
  resource_type_group: ResourceTypeGroupEnum
  format: Array<CourseResourceFormatInner>
  pace: Array<CourseResourcePaceInner>
  children: LearningResourceRelationshipChildField | null
  /**
   * Return the best run id for the resource, if it has runs
   */
  best_run_id: number | null
  /**
   * Where this resource lives within Learn
   */
  learn_url: string
  /**
   * Slug derived from the title, for use in this resource\'s URL. It is cosmetic: lookups ignore it, and it changes whenever the title does. Titles that yield no ASCII slug get the literal \"resource\", so this is never blank.
   */
  url_slug: string
  resource_type: VideoResourceResourceTypeEnum
  video: Video | null
  /**
   * Get the playlist id(s) the video belongs to
   */
  playlists: Array<string>
  content_files: Array<NestedContentFile> | null
  description: string | null
  readable_id: string
  title: string
  full_description?: string | null
  last_modified?: string | null
  published?: boolean
  languages?: Array<string> | null
  url?: string | null
  /**
   * The display category for this resource.
   */
  resource_category: string
  ocw_topics?: Array<string>
  professional: boolean
  next_start_date?: string | null
  availability?: VideoResourceAvailabilityEnum | null
  completeness?: number
  license_cc?: boolean
  test_mode?: boolean
  continuing_ed_credits?: string | null
  location?: string
  duration?: string
  min_weeks?: number | null
  max_weeks?: number | null
  time_commitment?: string
  min_weekly_hours?: number | null
  max_weekly_hours?: number | null
  require_summaries: boolean
}

export const VideoResourceAvailabilityEnum = {
  Dated: "dated",
  Anytime: "anytime",
} as const

export type VideoResourceAvailabilityEnum =
  (typeof VideoResourceAvailabilityEnum)[keyof typeof VideoResourceAvailabilityEnum]

export const VideoResourceResourceTypeEnumDescriptions = {
  video: "",
} as const

export const VideoResourceResourceTypeEnum = {
  Video: "video",
} as const

export type VideoResourceResourceTypeEnum =
  (typeof VideoResourceResourceTypeEnum)[keyof typeof VideoResourceResourceTypeEnum]

/**
 * @type VideoStreamingUrl
 */
export type VideoStreamingUrl = string

/**
 * WidgetInstance serializer
 */
export interface WidgetInstance {
  id: number
  widget_type: WidgetTypeEnum
  title: string
  /**
   * Returns the configuration to serialize
   */
  configuration?: { [key: string]: any }
  /**
   * Renders the widget to json based on configuration
   */
  json: { [key: string]: any } | null
}

/**
 * Serializer for WidgetLists
 */
export interface WidgetList {
  id: number
  widgets?: Array<WidgetInstance> | null
  available_widgets: Array<WidgetListAvailableWidgetsInner>
}
export interface WidgetListAvailableWidgetsInner {
  widget_type?: string
  description?: string
  form_spec?: object
}
/**
 * Serializer for WidgetLists
 */
export interface WidgetListRequest {
  widgets?: Array<WidgetInstance> | null
}
/**
 * * `Markdown` - Markdown * `URL` - URL * `People` - People
 */

export const WidgetTypeEnumDescriptions = {
  Markdown: "Markdown",
  URL: "URL",
  People: "People",
} as const

export const WidgetTypeEnum = {
  /**
   * Markdown
   */
  Markdown: "Markdown",
  /**
   * URL
   */
  Url: "URL",
  /**
   * People
   */
  People: "People",
} as const

export type WidgetTypeEnum =
  (typeof WidgetTypeEnum)[keyof typeof WidgetTypeEnum]

/**
 * ChannelsApi - axios parameter creator
 */
export const ChannelsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * List channel counts by resource type.
     * @summary Channel Counts by channel type
     * @param {string} channel_type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsCountsList: async (
      channel_type: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'channel_type' is not null or undefined
      assertParamExists("channelsCountsList", "channel_type", channel_type)
      const localVarPath = `/api/v0/channels/counts/{channel_type}/`.replace(
        "{channel_type}",
        encodeURIComponent(String(channel_type)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List published channels.
     * @summary List
     * @param {ChannelsListChannelTypeEnum} [channel_type] * &#x60;topic&#x60; - Topic * &#x60;department&#x60; - Department * &#x60;unit&#x60; - Unit * &#x60;pathway&#x60; - Pathway
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsList: async (
      channel_type?: ChannelsListChannelTypeEnum,
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/channels/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (channel_type !== undefined) {
        localVarQueryParameter["channel_type"] = channel_type
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single channel by id.
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this channel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("channelsRetrieve", "id", id)
      const localVarPath = `/api/v0/channels/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Resources in the channel\'s featured learning path, in the order the path lists them.
     * @summary Channel Featured Resources
     * @param {string} channel_type
     * @param {string} name
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsTypeFeaturedList: async (
      channel_type: string,
      name: string,
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'channel_type' is not null or undefined
      assertParamExists(
        "channelsTypeFeaturedList",
        "channel_type",
        channel_type,
      )
      // verify required parameter 'name' is not null or undefined
      assertParamExists("channelsTypeFeaturedList", "name", name)
      const localVarPath =
        `/api/v0/channels/type/{channel_type}/{name}/featured/`
          .replace("{channel_type}", encodeURIComponent(String(channel_type)))
          .replace("{name}", encodeURIComponent(String(name)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for retrieving an individual channel by type and name
     * @summary Channel Detail Lookup by channel type and name
     * @param {string} channel_type
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsTypeRetrieve: async (
      channel_type: string,
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'channel_type' is not null or undefined
      assertParamExists("channelsTypeRetrieve", "channel_type", channel_type)
      // verify required parameter 'name' is not null or undefined
      assertParamExists("channelsTypeRetrieve", "name", name)
      const localVarPath = `/api/v0/channels/type/{channel_type}/{name}/`
        .replace("{channel_type}", encodeURIComponent(String(channel_type)))
        .replace("{name}", encodeURIComponent(String(name)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ChannelsApi - functional programming interface
 */
export const ChannelsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ChannelsApiAxiosParamCreator(configuration)
  return {
    /**
     * List channel counts by resource type.
     * @summary Channel Counts by channel type
     * @param {string} channel_type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async channelsCountsList(
      channel_type: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ChannelCounts>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.channelsCountsList(
          channel_type,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ChannelsApi.channelsCountsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * List published channels.
     * @summary List
     * @param {ChannelsListChannelTypeEnum} [channel_type] * &#x60;topic&#x60; - Topic * &#x60;department&#x60; - Department * &#x60;unit&#x60; - Unit * &#x60;pathway&#x60; - Pathway
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async channelsList(
      channel_type?: ChannelsListChannelTypeEnum,
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedChannelList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.channelsList(
        channel_type,
        limit,
        offset,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ChannelsApi.channelsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single channel by id.
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this channel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async channelsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Channel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.channelsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ChannelsApi.channelsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Resources in the channel\'s featured learning path, in the order the path lists them.
     * @summary Channel Featured Resources
     * @param {string} channel_type
     * @param {string} name
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async channelsTypeFeaturedList(
      channel_type: string,
      name: string,
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedLearningResourceList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.channelsTypeFeaturedList(
          channel_type,
          name,
          limit,
          offset,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ChannelsApi.channelsTypeFeaturedList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for retrieving an individual channel by type and name
     * @summary Channel Detail Lookup by channel type and name
     * @param {string} channel_type
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async channelsTypeRetrieve(
      channel_type: string,
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Channel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.channelsTypeRetrieve(
          channel_type,
          name,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ChannelsApi.channelsTypeRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ChannelsApi - factory interface
 */
export const ChannelsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ChannelsApiFp(configuration)
  return {
    /**
     * List channel counts by resource type.
     * @summary Channel Counts by channel type
     * @param {ChannelsApiChannelsCountsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsCountsList(
      requestParameters: ChannelsApiChannelsCountsListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ChannelCounts>> {
      return localVarFp
        .channelsCountsList(requestParameters.channel_type, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List published channels.
     * @summary List
     * @param {ChannelsApiChannelsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsList(
      requestParameters: ChannelsApiChannelsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedChannelList> {
      return localVarFp
        .channelsList(
          requestParameters.channel_type,
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single channel by id.
     * @summary Retrieve
     * @param {ChannelsApiChannelsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsRetrieve(
      requestParameters: ChannelsApiChannelsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Channel> {
      return localVarFp
        .channelsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Resources in the channel\'s featured learning path, in the order the path lists them.
     * @summary Channel Featured Resources
     * @param {ChannelsApiChannelsTypeFeaturedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsTypeFeaturedList(
      requestParameters: ChannelsApiChannelsTypeFeaturedListRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedLearningResourceList> {
      return localVarFp
        .channelsTypeFeaturedList(
          requestParameters.channel_type,
          requestParameters.name,
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * View for retrieving an individual channel by type and name
     * @summary Channel Detail Lookup by channel type and name
     * @param {ChannelsApiChannelsTypeRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    channelsTypeRetrieve(
      requestParameters: ChannelsApiChannelsTypeRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Channel> {
      return localVarFp
        .channelsTypeRetrieve(
          requestParameters.channel_type,
          requestParameters.name,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for channelsCountsList operation in ChannelsApi.
 */
export interface ChannelsApiChannelsCountsListRequest {
  readonly channel_type: string
}

/**
 * Request parameters for channelsList operation in ChannelsApi.
 */
export interface ChannelsApiChannelsListRequest {
  /**
   * * &#x60;topic&#x60; - Topic * &#x60;department&#x60; - Department * &#x60;unit&#x60; - Unit * &#x60;pathway&#x60; - Pathway
   */
  readonly channel_type?: ChannelsListChannelTypeEnum

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for channelsRetrieve operation in ChannelsApi.
 */
export interface ChannelsApiChannelsRetrieveRequest {
  /**
   * A unique integer value identifying this channel.
   */
  readonly id: number
}

/**
 * Request parameters for channelsTypeFeaturedList operation in ChannelsApi.
 */
export interface ChannelsApiChannelsTypeFeaturedListRequest {
  readonly channel_type: string

  readonly name: string

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for channelsTypeRetrieve operation in ChannelsApi.
 */
export interface ChannelsApiChannelsTypeRetrieveRequest {
  readonly channel_type: string

  readonly name: string
}

/**
 * ChannelsApi - object-oriented interface
 */
export class ChannelsApi extends BaseAPI {
  /**
   * List channel counts by resource type.
   * @summary Channel Counts by channel type
   * @param {ChannelsApiChannelsCountsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public channelsCountsList(
    requestParameters: ChannelsApiChannelsCountsListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ChannelsApiFp(this.configuration)
      .channelsCountsList(requestParameters.channel_type, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List published channels.
   * @summary List
   * @param {ChannelsApiChannelsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public channelsList(
    requestParameters: ChannelsApiChannelsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return ChannelsApiFp(this.configuration)
      .channelsList(
        requestParameters.channel_type,
        requestParameters.limit,
        requestParameters.offset,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single channel by id.
   * @summary Retrieve
   * @param {ChannelsApiChannelsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public channelsRetrieve(
    requestParameters: ChannelsApiChannelsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ChannelsApiFp(this.configuration)
      .channelsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Resources in the channel\'s featured learning path, in the order the path lists them.
   * @summary Channel Featured Resources
   * @param {ChannelsApiChannelsTypeFeaturedListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public channelsTypeFeaturedList(
    requestParameters: ChannelsApiChannelsTypeFeaturedListRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ChannelsApiFp(this.configuration)
      .channelsTypeFeaturedList(
        requestParameters.channel_type,
        requestParameters.name,
        requestParameters.limit,
        requestParameters.offset,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for retrieving an individual channel by type and name
   * @summary Channel Detail Lookup by channel type and name
   * @param {ChannelsApiChannelsTypeRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public channelsTypeRetrieve(
    requestParameters: ChannelsApiChannelsTypeRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ChannelsApiFp(this.configuration)
      .channelsTypeRetrieve(
        requestParameters.channel_type,
        requestParameters.name,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const ChannelsListChannelTypeEnum = {
  Department: "department",
  Pathway: "pathway",
  Topic: "topic",
  Unit: "unit",
} as const
export type ChannelsListChannelTypeEnum =
  (typeof ChannelsListChannelTypeEnum)[keyof typeof ChannelsListChannelTypeEnum]

/**
 * CkeditorApi - axios parameter creator
 */
export const CkeditorApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get the settings response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ckeditorRetrieve: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/ckeditor`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CkeditorApi - functional programming interface
 */
export const CkeditorApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CkeditorApiAxiosParamCreator(configuration)
  return {
    /**
     * Get the settings response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ckeditorRetrieve(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CKEditorSettings>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.ckeditorRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CkeditorApi.ckeditorRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CkeditorApi - factory interface
 */
export const CkeditorApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CkeditorApiFp(configuration)
  return {
    /**
     * Get the settings response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ckeditorRetrieve(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CKEditorSettings> {
      return localVarFp
        .ckeditorRetrieve(options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * CkeditorApi - object-oriented interface
 */
export class CkeditorApi extends BaseAPI {
  /**
   * Get the settings response
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public ckeditorRetrieve(options?: RawAxiosRequestConfig) {
    return CkeditorApiFp(this.configuration)
      .ckeditorRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ContentFeedbackApi - axios parameter creator
 */
export const ContentFeedbackApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Accept per-block content feedback submissions (append-only).
     * @param {ContentFeedbackRequest} ContentFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentFeedbackCreate: async (
      ContentFeedbackRequest: ContentFeedbackRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ContentFeedbackRequest' is not null or undefined
      assertParamExists(
        "contentFeedbackCreate",
        "ContentFeedbackRequest",
        ContentFeedbackRequest,
      )
      const localVarPath = `/api/v0/content_feedback/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        ContentFeedbackRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ContentFeedbackApi - functional programming interface
 */
export const ContentFeedbackApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ContentFeedbackApiAxiosParamCreator(configuration)
  return {
    /**
     * Accept per-block content feedback submissions (append-only).
     * @param {ContentFeedbackRequest} ContentFeedbackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contentFeedbackCreate(
      ContentFeedbackRequest: ContentFeedbackRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ContentFeedback>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contentFeedbackCreate(
          ContentFeedbackRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ContentFeedbackApi.contentFeedbackCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ContentFeedbackApi - factory interface
 */
export const ContentFeedbackApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ContentFeedbackApiFp(configuration)
  return {
    /**
     * Accept per-block content feedback submissions (append-only).
     * @param {ContentFeedbackApiContentFeedbackCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contentFeedbackCreate(
      requestParameters: ContentFeedbackApiContentFeedbackCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ContentFeedback> {
      return localVarFp
        .contentFeedbackCreate(
          requestParameters.ContentFeedbackRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for contentFeedbackCreate operation in ContentFeedbackApi.
 */
export interface ContentFeedbackApiContentFeedbackCreateRequest {
  readonly ContentFeedbackRequest: ContentFeedbackRequest
}

/**
 * ContentFeedbackApi - object-oriented interface
 */
export class ContentFeedbackApi extends BaseAPI {
  /**
   * Accept per-block content feedback submissions (append-only).
   * @param {ContentFeedbackApiContentFeedbackCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public contentFeedbackCreate(
    requestParameters: ContentFeedbackApiContentFeedbackCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ContentFeedbackApiFp(this.configuration)
      .contentFeedbackCreate(requestParameters.ContentFeedbackRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CredentialMetadataApi - axios parameter creator
 */
export const CredentialMetadataApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Read or generate Open Badges credential metadata for a learning resource.  Limited to MITx Online courses.
     * @summary Generate credential metadata
     * @param {CredentialMetadataRequestRequest} CredentialMetadataRequestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    credentialMetadataCreate: async (
      CredentialMetadataRequestRequest: CredentialMetadataRequestRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'CredentialMetadataRequestRequest' is not null or undefined
      assertParamExists(
        "credentialMetadataCreate",
        "CredentialMetadataRequestRequest",
        CredentialMetadataRequestRequest,
      )
      const localVarPath = `/api/v0/credential_metadata/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        CredentialMetadataRequestRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Read or generate Open Badges credential metadata for a learning resource.  Limited to MITx Online courses.
     * @summary Get stored credential metadata
     * @param {string} resource_readable_id The readable id of the learning resource to fetch stored metadata for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    credentialMetadataRetrieve: async (
      resource_readable_id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'resource_readable_id' is not null or undefined
      assertParamExists(
        "credentialMetadataRetrieve",
        "resource_readable_id",
        resource_readable_id,
      )
      const localVarPath = `/api/v0/credential_metadata/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (resource_readable_id !== undefined) {
        localVarQueryParameter["resource_readable_id"] = resource_readable_id
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CredentialMetadataApi - functional programming interface
 */
export const CredentialMetadataApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    CredentialMetadataApiAxiosParamCreator(configuration)
  return {
    /**
     * Read or generate Open Badges credential metadata for a learning resource.  Limited to MITx Online courses.
     * @summary Generate credential metadata
     * @param {CredentialMetadataRequestRequest} CredentialMetadataRequestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async credentialMetadataCreate(
      CredentialMetadataRequestRequest: CredentialMetadataRequestRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CredentialMetadata>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.credentialMetadataCreate(
          CredentialMetadataRequestRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["CredentialMetadataApi.credentialMetadataCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Read or generate Open Badges credential metadata for a learning resource.  Limited to MITx Online courses.
     * @summary Get stored credential metadata
     * @param {string} resource_readable_id The readable id of the learning resource to fetch stored metadata for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async credentialMetadataRetrieve(
      resource_readable_id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CredentialMetadata>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.credentialMetadataRetrieve(
          resource_readable_id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "CredentialMetadataApi.credentialMetadataRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CredentialMetadataApi - factory interface
 */
export const CredentialMetadataApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CredentialMetadataApiFp(configuration)
  return {
    /**
     * Read or generate Open Badges credential metadata for a learning resource.  Limited to MITx Online courses.
     * @summary Generate credential metadata
     * @param {CredentialMetadataApiCredentialMetadataCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    credentialMetadataCreate(
      requestParameters: CredentialMetadataApiCredentialMetadataCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CredentialMetadata> {
      return localVarFp
        .credentialMetadataCreate(
          requestParameters.CredentialMetadataRequestRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Read or generate Open Badges credential metadata for a learning resource.  Limited to MITx Online courses.
     * @summary Get stored credential metadata
     * @param {CredentialMetadataApiCredentialMetadataRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    credentialMetadataRetrieve(
      requestParameters: CredentialMetadataApiCredentialMetadataRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CredentialMetadata> {
      return localVarFp
        .credentialMetadataRetrieve(
          requestParameters.resource_readable_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for credentialMetadataCreate operation in CredentialMetadataApi.
 */
export interface CredentialMetadataApiCredentialMetadataCreateRequest {
  readonly CredentialMetadataRequestRequest: CredentialMetadataRequestRequest
}

/**
 * Request parameters for credentialMetadataRetrieve operation in CredentialMetadataApi.
 */
export interface CredentialMetadataApiCredentialMetadataRetrieveRequest {
  /**
   * The readable id of the learning resource to fetch stored metadata for
   */
  readonly resource_readable_id: string
}

/**
 * CredentialMetadataApi - object-oriented interface
 */
export class CredentialMetadataApi extends BaseAPI {
  /**
   * Read or generate Open Badges credential metadata for a learning resource.  Limited to MITx Online courses.
   * @summary Generate credential metadata
   * @param {CredentialMetadataApiCredentialMetadataCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public credentialMetadataCreate(
    requestParameters: CredentialMetadataApiCredentialMetadataCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialMetadataApiFp(this.configuration)
      .credentialMetadataCreate(
        requestParameters.CredentialMetadataRequestRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Read or generate Open Badges credential metadata for a learning resource.  Limited to MITx Online courses.
   * @summary Get stored credential metadata
   * @param {CredentialMetadataApiCredentialMetadataRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public credentialMetadataRetrieve(
    requestParameters: CredentialMetadataApiCredentialMetadataRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialMetadataApiFp(this.configuration)
      .credentialMetadataRetrieve(
        requestParameters.resource_readable_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * LearningResourcesSearchAdminParamsApi - axios parameter creator
 */
export const LearningResourcesSearchAdminParamsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Learning resource search default admin param values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesSearchAdminParamsRetrieve: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/learning_resources_search_admin_params/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LearningResourcesSearchAdminParamsApi - functional programming interface
 */
export const LearningResourcesSearchAdminParamsApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    LearningResourcesSearchAdminParamsApiAxiosParamCreator(configuration)
  return {
    /**
     * Learning resource search default admin param values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async learningResourcesSearchAdminParamsRetrieve(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.learningResourcesSearchAdminParamsRetrieve(
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "LearningResourcesSearchAdminParamsApi.learningResourcesSearchAdminParamsRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LearningResourcesSearchAdminParamsApi - factory interface
 */
export const LearningResourcesSearchAdminParamsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LearningResourcesSearchAdminParamsApiFp(configuration)
  return {
    /**
     * Learning resource search default admin param values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    learningResourcesSearchAdminParamsRetrieve(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .learningResourcesSearchAdminParamsRetrieve(options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * LearningResourcesSearchAdminParamsApi - object-oriented interface
 */
export class LearningResourcesSearchAdminParamsApi extends BaseAPI {
  /**
   * Learning resource search default admin param values
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public learningResourcesSearchAdminParamsRetrieve(
    options?: RawAxiosRequestConfig,
  ) {
    return LearningResourcesSearchAdminParamsApiFp(this.configuration)
      .learningResourcesSearchAdminParamsRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * NewsEventsApi - axios parameter creator
 */
export const NewsEventsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a paginated list of feed items.
     * @param {Array<NewsEventsListFeedTypeEnum>} [feed_type] The type of item  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {NewsEventsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;event_date&#x60; - Event date ascending * &#x60;-event_date&#x60; - Event date  descending * &#x60;news_date&#x60; - Creation date ascending * &#x60;-news_date&#x60; - Creation date descending
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    newsEventsList: async (
      feed_type?: Array<NewsEventsListFeedTypeEnum>,
      limit?: number,
      offset?: number,
      sortby?: NewsEventsListSortbyEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/news_events/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (feed_type) {
        localVarQueryParameter["feed_type"] = feed_type
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single feed item.
     * @param {number} id A unique integer value identifying this feed item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    newsEventsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("newsEventsRetrieve", "id", id)
      const localVarPath = `/api/v0/news_events/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * NewsEventsApi - functional programming interface
 */
export const NewsEventsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    NewsEventsApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a paginated list of feed items.
     * @param {Array<NewsEventsListFeedTypeEnum>} [feed_type] The type of item  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {NewsEventsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;event_date&#x60; - Event date ascending * &#x60;-event_date&#x60; - Event date  descending * &#x60;news_date&#x60; - Creation date ascending * &#x60;-news_date&#x60; - Creation date descending
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async newsEventsList(
      feed_type?: Array<NewsEventsListFeedTypeEnum>,
      limit?: number,
      offset?: number,
      sortby?: NewsEventsListSortbyEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedFeedItemList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.newsEventsList(
        feed_type,
        limit,
        offset,
        sortby,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["NewsEventsApi.newsEventsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single feed item.
     * @param {number} id A unique integer value identifying this feed item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async newsEventsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedItem>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.newsEventsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["NewsEventsApi.newsEventsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * NewsEventsApi - factory interface
 */
export const NewsEventsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = NewsEventsApiFp(configuration)
  return {
    /**
     * Get a paginated list of feed items.
     * @param {NewsEventsApiNewsEventsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    newsEventsList(
      requestParameters: NewsEventsApiNewsEventsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedFeedItemList> {
      return localVarFp
        .newsEventsList(
          requestParameters.feed_type,
          requestParameters.limit,
          requestParameters.offset,
          requestParameters.sortby,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single feed item.
     * @param {NewsEventsApiNewsEventsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    newsEventsRetrieve(
      requestParameters: NewsEventsApiNewsEventsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FeedItem> {
      return localVarFp
        .newsEventsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for newsEventsList operation in NewsEventsApi.
 */
export interface NewsEventsApiNewsEventsListRequest {
  /**
   * The type of item  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
   */
  readonly feed_type?: Array<NewsEventsListFeedTypeEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;event_date&#x60; - Event date ascending * &#x60;-event_date&#x60; - Event date  descending * &#x60;news_date&#x60; - Creation date ascending * &#x60;-news_date&#x60; - Creation date descending
   */
  readonly sortby?: NewsEventsListSortbyEnum
}

/**
 * Request parameters for newsEventsRetrieve operation in NewsEventsApi.
 */
export interface NewsEventsApiNewsEventsRetrieveRequest {
  /**
   * A unique integer value identifying this feed item.
   */
  readonly id: number
}

/**
 * NewsEventsApi - object-oriented interface
 */
export class NewsEventsApi extends BaseAPI {
  /**
   * Get a paginated list of feed items.
   * @param {NewsEventsApiNewsEventsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public newsEventsList(
    requestParameters: NewsEventsApiNewsEventsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return NewsEventsApiFp(this.configuration)
      .newsEventsList(
        requestParameters.feed_type,
        requestParameters.limit,
        requestParameters.offset,
        requestParameters.sortby,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single feed item.
   * @param {NewsEventsApiNewsEventsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public newsEventsRetrieve(
    requestParameters: NewsEventsApiNewsEventsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NewsEventsApiFp(this.configuration)
      .newsEventsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const NewsEventsListFeedTypeEnum = {
  Events: "events",
  News: "news",
} as const
export type NewsEventsListFeedTypeEnum =
  (typeof NewsEventsListFeedTypeEnum)[keyof typeof NewsEventsListFeedTypeEnum]
export const NewsEventsListSortbyEnum = {
  EventDate: "-event_date",
  Id: "-id",
  NewsDate: "-news_date",
  EventDate2: "event_date",
  Id2: "id",
  NewsDate2: "news_date",
} as const
export type NewsEventsListSortbyEnum =
  (typeof NewsEventsListSortbyEnum)[keyof typeof NewsEventsListSortbyEnum]

/**
 * NewsEventsSourcesApi - axios parameter creator
 */
export const NewsEventsSourcesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get a paginated list of news/event feed sources.
     * @param {Array<NewsEventsSourcesListFeedTypeEnum>} [feed_type] The type of source  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    newsEventsSourcesList: async (
      feed_type?: Array<NewsEventsSourcesListFeedTypeEnum>,
      limit?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/news_events_sources/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (feed_type) {
        localVarQueryParameter["feed_type"] = feed_type
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a single news/event feed source.
     * @param {number} id A unique integer value identifying this feed source.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    newsEventsSourcesRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("newsEventsSourcesRetrieve", "id", id)
      const localVarPath = `/api/v0/news_events_sources/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * NewsEventsSourcesApi - functional programming interface
 */
export const NewsEventsSourcesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    NewsEventsSourcesApiAxiosParamCreator(configuration)
  return {
    /**
     * Get a paginated list of news/event feed sources.
     * @param {Array<NewsEventsSourcesListFeedTypeEnum>} [feed_type] The type of source  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async newsEventsSourcesList(
      feed_type?: Array<NewsEventsSourcesListFeedTypeEnum>,
      limit?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedFeedSourceList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.newsEventsSourcesList(
          feed_type,
          limit,
          offset,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["NewsEventsSourcesApi.newsEventsSourcesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a single news/event feed source.
     * @param {number} id A unique integer value identifying this feed source.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async newsEventsSourcesRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedSource>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.newsEventsSourcesRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["NewsEventsSourcesApi.newsEventsSourcesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * NewsEventsSourcesApi - factory interface
 */
export const NewsEventsSourcesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = NewsEventsSourcesApiFp(configuration)
  return {
    /**
     * Get a paginated list of news/event feed sources.
     * @param {NewsEventsSourcesApiNewsEventsSourcesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    newsEventsSourcesList(
      requestParameters: NewsEventsSourcesApiNewsEventsSourcesListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedFeedSourceList> {
      return localVarFp
        .newsEventsSourcesList(
          requestParameters.feed_type,
          requestParameters.limit,
          requestParameters.offset,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a single news/event feed source.
     * @param {NewsEventsSourcesApiNewsEventsSourcesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    newsEventsSourcesRetrieve(
      requestParameters: NewsEventsSourcesApiNewsEventsSourcesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FeedSource> {
      return localVarFp
        .newsEventsSourcesRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for newsEventsSourcesList operation in NewsEventsSourcesApi.
 */
export interface NewsEventsSourcesApiNewsEventsSourcesListRequest {
  /**
   * The type of source  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
   */
  readonly feed_type?: Array<NewsEventsSourcesListFeedTypeEnum>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number
}

/**
 * Request parameters for newsEventsSourcesRetrieve operation in NewsEventsSourcesApi.
 */
export interface NewsEventsSourcesApiNewsEventsSourcesRetrieveRequest {
  /**
   * A unique integer value identifying this feed source.
   */
  readonly id: number
}

/**
 * NewsEventsSourcesApi - object-oriented interface
 */
export class NewsEventsSourcesApi extends BaseAPI {
  /**
   * Get a paginated list of news/event feed sources.
   * @param {NewsEventsSourcesApiNewsEventsSourcesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public newsEventsSourcesList(
    requestParameters: NewsEventsSourcesApiNewsEventsSourcesListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return NewsEventsSourcesApiFp(this.configuration)
      .newsEventsSourcesList(
        requestParameters.feed_type,
        requestParameters.limit,
        requestParameters.offset,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a single news/event feed source.
   * @param {NewsEventsSourcesApiNewsEventsSourcesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public newsEventsSourcesRetrieve(
    requestParameters: NewsEventsSourcesApiNewsEventsSourcesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NewsEventsSourcesApiFp(this.configuration)
      .newsEventsSourcesRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const NewsEventsSourcesListFeedTypeEnum = {
  Events: "events",
  News: "news",
} as const
export type NewsEventsSourcesListFeedTypeEnum =
  (typeof NewsEventsSourcesListFeedTypeEnum)[keyof typeof NewsEventsSourcesListFeedTypeEnum]

/**
 * ProfilesApi - axios parameter creator
 */
export const ProfilesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * View for profile
     * @param {string} user__username
     * @param {PatchedProfileRequest} [PatchedProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilesPartialUpdate: async (
      user__username: string,
      PatchedProfileRequest?: PatchedProfileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'user__username' is not null or undefined
      assertParamExists(
        "profilesPartialUpdate",
        "user__username",
        user__username,
      )
      const localVarPath = `/api/v0/profiles/{user__username}/`.replace(
        "{user__username}",
        encodeURIComponent(String(user__username)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedProfileRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for profile
     * @param {string} user__username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilesRetrieve: async (
      user__username: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'user__username' is not null or undefined
      assertParamExists("profilesRetrieve", "user__username", user__username)
      const localVarPath = `/api/v0/profiles/{user__username}/`.replace(
        "{user__username}",
        encodeURIComponent(String(user__username)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for profile
     * @param {string} user__username
     * @param {ProfileRequest} [ProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilesUpdate: async (
      user__username: string,
      ProfileRequest?: ProfileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'user__username' is not null or undefined
      assertParamExists("profilesUpdate", "user__username", user__username)
      const localVarPath = `/api/v0/profiles/{user__username}/`.replace(
        "{user__username}",
        encodeURIComponent(String(user__username)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        ProfileRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProfilesApi - functional programming interface
 */
export const ProfilesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProfilesApiAxiosParamCreator(configuration)
  return {
    /**
     * View for profile
     * @param {string} user__username
     * @param {PatchedProfileRequest} [PatchedProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profilesPartialUpdate(
      user__username: string,
      PatchedProfileRequest?: PatchedProfileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.profilesPartialUpdate(
          user__username,
          PatchedProfileRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProfilesApi.profilesPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for profile
     * @param {string} user__username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profilesRetrieve(
      user__username: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.profilesRetrieve(
          user__username,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProfilesApi.profilesRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for profile
     * @param {string} user__username
     * @param {ProfileRequest} [ProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profilesUpdate(
      user__username: string,
      ProfileRequest?: ProfileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profilesUpdate(
        user__username,
        ProfileRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProfilesApi.profilesUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ProfilesApi - factory interface
 */
export const ProfilesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ProfilesApiFp(configuration)
  return {
    /**
     * View for profile
     * @param {ProfilesApiProfilesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilesPartialUpdate(
      requestParameters: ProfilesApiProfilesPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Profile> {
      return localVarFp
        .profilesPartialUpdate(
          requestParameters.user__username,
          requestParameters.PatchedProfileRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * View for profile
     * @param {ProfilesApiProfilesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilesRetrieve(
      requestParameters: ProfilesApiProfilesRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Profile> {
      return localVarFp
        .profilesRetrieve(requestParameters.user__username, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * View for profile
     * @param {ProfilesApiProfilesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilesUpdate(
      requestParameters: ProfilesApiProfilesUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Profile> {
      return localVarFp
        .profilesUpdate(
          requestParameters.user__username,
          requestParameters.ProfileRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for profilesPartialUpdate operation in ProfilesApi.
 */
export interface ProfilesApiProfilesPartialUpdateRequest {
  readonly user__username: string

  readonly PatchedProfileRequest?: PatchedProfileRequest
}

/**
 * Request parameters for profilesRetrieve operation in ProfilesApi.
 */
export interface ProfilesApiProfilesRetrieveRequest {
  readonly user__username: string
}

/**
 * Request parameters for profilesUpdate operation in ProfilesApi.
 */
export interface ProfilesApiProfilesUpdateRequest {
  readonly user__username: string

  readonly ProfileRequest?: ProfileRequest
}

/**
 * ProfilesApi - object-oriented interface
 */
export class ProfilesApi extends BaseAPI {
  /**
   * View for profile
   * @param {ProfilesApiProfilesPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public profilesPartialUpdate(
    requestParameters: ProfilesApiProfilesPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProfilesApiFp(this.configuration)
      .profilesPartialUpdate(
        requestParameters.user__username,
        requestParameters.PatchedProfileRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for profile
   * @param {ProfilesApiProfilesRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public profilesRetrieve(
    requestParameters: ProfilesApiProfilesRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProfilesApiFp(this.configuration)
      .profilesRetrieve(requestParameters.user__username, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for profile
   * @param {ProfilesApiProfilesUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public profilesUpdate(
    requestParameters: ProfilesApiProfilesUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProfilesApiFp(this.configuration)
      .profilesUpdate(
        requestParameters.user__username,
        requestParameters.ProfileRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProgramCertificatesApi - axios parameter creator
 */
export const ProgramCertificatesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * View for listing program certificates for a user (includes program letter links)
     * @param {number} [micromasters_program_id]
     * @param {string} [program_title]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    programCertificatesList: async (
      micromasters_program_id?: number,
      program_title?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/program_certificates/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (micromasters_program_id !== undefined) {
        localVarQueryParameter["micromasters_program_id"] =
          micromasters_program_id
      }

      if (program_title !== undefined) {
        localVarQueryParameter["program_title"] = program_title
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProgramCertificatesApi - functional programming interface
 */
export const ProgramCertificatesApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    ProgramCertificatesApiAxiosParamCreator(configuration)
  return {
    /**
     * View for listing program certificates for a user (includes program letter links)
     * @param {number} [micromasters_program_id]
     * @param {string} [program_title]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async programCertificatesList(
      micromasters_program_id?: number,
      program_title?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ProgramCertificate>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.programCertificatesList(
          micromasters_program_id,
          program_title,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ProgramCertificatesApi.programCertificatesList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ProgramCertificatesApi - factory interface
 */
export const ProgramCertificatesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ProgramCertificatesApiFp(configuration)
  return {
    /**
     * View for listing program certificates for a user (includes program letter links)
     * @param {ProgramCertificatesApiProgramCertificatesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    programCertificatesList(
      requestParameters: ProgramCertificatesApiProgramCertificatesListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ProgramCertificate>> {
      return localVarFp
        .programCertificatesList(
          requestParameters.micromasters_program_id,
          requestParameters.program_title,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for programCertificatesList operation in ProgramCertificatesApi.
 */
export interface ProgramCertificatesApiProgramCertificatesListRequest {
  readonly micromasters_program_id?: number

  readonly program_title?: string
}

/**
 * ProgramCertificatesApi - object-oriented interface
 */
export class ProgramCertificatesApi extends BaseAPI {
  /**
   * View for listing program certificates for a user (includes program letter links)
   * @param {ProgramCertificatesApiProgramCertificatesListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public programCertificatesList(
    requestParameters: ProgramCertificatesApiProgramCertificatesListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return ProgramCertificatesApiFp(this.configuration)
      .programCertificatesList(
        requestParameters.micromasters_program_id,
        requestParameters.program_title,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TestimonialsApi - axios parameter creator
 */
export const TestimonialsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * List all testimonials.
     * @summary List
     * @param {Array<number>} [channels] The channels the attestation is for
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<string>} [offerors] The offerors the attestation is for
     * @param {number} [offset] The initial index from which to return the results.
     * @param {number} [position] Only show items that exist at this position
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    testimonialsList: async (
      channels?: Array<number>,
      limit?: number,
      offerors?: Array<string>,
      offset?: number,
      position?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/testimonials/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (channels) {
        localVarQueryParameter["channels"] = channels
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offerors) {
        localVarQueryParameter["offerors"] = offerors
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (position !== undefined) {
        localVarQueryParameter["position"] = position
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a testimonial.
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this attestation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    testimonialsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("testimonialsRetrieve", "id", id)
      const localVarPath = `/api/v0/testimonials/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TestimonialsApi - functional programming interface
 */
export const TestimonialsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    TestimonialsApiAxiosParamCreator(configuration)
  return {
    /**
     * List all testimonials.
     * @summary List
     * @param {Array<number>} [channels] The channels the attestation is for
     * @param {number} [limit] Number of results to return per page.
     * @param {Array<string>} [offerors] The offerors the attestation is for
     * @param {number} [offset] The initial index from which to return the results.
     * @param {number} [position] Only show items that exist at this position
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async testimonialsList(
      channels?: Array<number>,
      limit?: number,
      offerors?: Array<string>,
      offset?: number,
      position?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PaginatedAttestationList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.testimonialsList(
          channels,
          limit,
          offerors,
          offset,
          position,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TestimonialsApi.testimonialsList"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a testimonial.
     * @summary Retrieve
     * @param {number} id A unique integer value identifying this attestation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async testimonialsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attestation>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.testimonialsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TestimonialsApi.testimonialsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * TestimonialsApi - factory interface
 */
export const TestimonialsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TestimonialsApiFp(configuration)
  return {
    /**
     * List all testimonials.
     * @summary List
     * @param {TestimonialsApiTestimonialsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    testimonialsList(
      requestParameters: TestimonialsApiTestimonialsListRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedAttestationList> {
      return localVarFp
        .testimonialsList(
          requestParameters.channels,
          requestParameters.limit,
          requestParameters.offerors,
          requestParameters.offset,
          requestParameters.position,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a testimonial.
     * @summary Retrieve
     * @param {TestimonialsApiTestimonialsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    testimonialsRetrieve(
      requestParameters: TestimonialsApiTestimonialsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Attestation> {
      return localVarFp
        .testimonialsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for testimonialsList operation in TestimonialsApi.
 */
export interface TestimonialsApiTestimonialsListRequest {
  /**
   * The channels the attestation is for
   */
  readonly channels?: Array<number>

  /**
   * Number of results to return per page.
   */
  readonly limit?: number

  /**
   * The offerors the attestation is for
   */
  readonly offerors?: Array<string>

  /**
   * The initial index from which to return the results.
   */
  readonly offset?: number

  /**
   * Only show items that exist at this position
   */
  readonly position?: number
}

/**
 * Request parameters for testimonialsRetrieve operation in TestimonialsApi.
 */
export interface TestimonialsApiTestimonialsRetrieveRequest {
  /**
   * A unique integer value identifying this attestation.
   */
  readonly id: number
}

/**
 * TestimonialsApi - object-oriented interface
 */
export class TestimonialsApi extends BaseAPI {
  /**
   * List all testimonials.
   * @summary List
   * @param {TestimonialsApiTestimonialsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public testimonialsList(
    requestParameters: TestimonialsApiTestimonialsListRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return TestimonialsApiFp(this.configuration)
      .testimonialsList(
        requestParameters.channels,
        requestParameters.limit,
        requestParameters.offerors,
        requestParameters.offset,
        requestParameters.position,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a testimonial.
   * @summary Retrieve
   * @param {TestimonialsApiTestimonialsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public testimonialsRetrieve(
    requestParameters: TestimonialsApiTestimonialsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TestimonialsApiFp(this.configuration)
      .testimonialsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TutorApi - axios parameter creator
 */
export const TutorApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieve a list of problem names for a course run
     * @summary Retrieve problem list
     * @param {string} run_readable_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProblems: async (
      run_readable_id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'run_readable_id' is not null or undefined
      assertParamExists("listProblems", "run_readable_id", run_readable_id)
      const localVarPath = `/api/v0/tutor/problems/{run_readable_id}/`.replace(
        "{run_readable_id}",
        encodeURIComponent(String(run_readable_id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieve a specific problem and its solution for a course run
     * @summary Retrieve Problem
     * @param {string} problem_title
     * @param {string} run_readable_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveProblem: async (
      problem_title: string,
      run_readable_id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'problem_title' is not null or undefined
      assertParamExists("retrieveProblem", "problem_title", problem_title)
      // verify required parameter 'run_readable_id' is not null or undefined
      assertParamExists("retrieveProblem", "run_readable_id", run_readable_id)
      const localVarPath =
        `/api/v0/tutor/problems/{run_readable_id}/{problem_title}/`
          .replace("{problem_title}", encodeURIComponent(String(problem_title)))
          .replace(
            "{run_readable_id}",
            encodeURIComponent(String(run_readable_id)),
          )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TutorApi - functional programming interface
 */
export const TutorApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TutorApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieve a list of problem names for a course run
     * @summary Retrieve problem list
     * @param {string} run_readable_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listProblems(
      run_readable_id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ProblemListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listProblems(
        run_readable_id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TutorApi.listProblems"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieve a specific problem and its solution for a course run
     * @summary Retrieve Problem
     * @param {string} problem_title
     * @param {string} run_readable_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async retrieveProblem(
      problem_title: string,
      run_readable_id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RetrieveProblemResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveProblem(
        problem_title,
        run_readable_id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TutorApi.retrieveProblem"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * TutorApi - factory interface
 */
export const TutorApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TutorApiFp(configuration)
  return {
    /**
     * Retrieve a list of problem names for a course run
     * @summary Retrieve problem list
     * @param {TutorApiListProblemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProblems(
      requestParameters: TutorApiListProblemsRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ProblemListResponse> {
      return localVarFp
        .listProblems(requestParameters.run_readable_id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieve a specific problem and its solution for a course run
     * @summary Retrieve Problem
     * @param {TutorApiRetrieveProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrieveProblem(
      requestParameters: TutorApiRetrieveProblemRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RetrieveProblemResponse> {
      return localVarFp
        .retrieveProblem(
          requestParameters.problem_title,
          requestParameters.run_readable_id,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for listProblems operation in TutorApi.
 */
export interface TutorApiListProblemsRequest {
  readonly run_readable_id: string
}

/**
 * Request parameters for retrieveProblem operation in TutorApi.
 */
export interface TutorApiRetrieveProblemRequest {
  readonly problem_title: string

  readonly run_readable_id: string
}

/**
 * TutorApi - object-oriented interface
 */
export class TutorApi extends BaseAPI {
  /**
   * Retrieve a list of problem names for a course run
   * @summary Retrieve problem list
   * @param {TutorApiListProblemsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public listProblems(
    requestParameters: TutorApiListProblemsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TutorApiFp(this.configuration)
      .listProblems(requestParameters.run_readable_id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieve a specific problem and its solution for a course run
   * @summary Retrieve Problem
   * @param {TutorApiRetrieveProblemRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public retrieveProblem(
    requestParameters: TutorApiRetrieveProblemRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TutorApiFp(this.configuration)
      .retrieveProblem(
        requestParameters.problem_title,
        requestParameters.run_readable_id,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * View for users
     * @param {UserRequest} UserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCreate: async (
      UserRequest: UserRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'UserRequest' is not null or undefined
      assertParamExists("usersCreate", "UserRequest", UserRequest)
      const localVarPath = `/api/v0/users/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        UserRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for users
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersDestroy: async (
      username: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'username' is not null or undefined
      assertParamExists("usersDestroy", "username", username)
      const localVarPath = `/api/v0/users/{username}/`.replace(
        "{username}",
        encodeURIComponent(String(username)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersList: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/users/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * User retrieve and update viewsets for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeRetrieve: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/users/me/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for users
     * @param {string} username
     * @param {PatchedUserRequest} [PatchedUserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersPartialUpdate: async (
      username: string,
      PatchedUserRequest?: PatchedUserRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'username' is not null or undefined
      assertParamExists("usersPartialUpdate", "username", username)
      const localVarPath = `/api/v0/users/{username}/`.replace(
        "{username}",
        encodeURIComponent(String(username)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedUserRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for users
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersRetrieve: async (
      username: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'username' is not null or undefined
      assertParamExists("usersRetrieve", "username", username)
      const localVarPath = `/api/v0/users/{username}/`.replace(
        "{username}",
        encodeURIComponent(String(username)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * View for users
     * @param {string} username
     * @param {UserRequest} UserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUpdate: async (
      username: string,
      UserRequest: UserRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'username' is not null or undefined
      assertParamExists("usersUpdate", "username", username)
      // verify required parameter 'UserRequest' is not null or undefined
      assertParamExists("usersUpdate", "UserRequest", UserRequest)
      const localVarPath = `/api/v0/users/{username}/`.replace(
        "{username}",
        encodeURIComponent(String(username)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        UserRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
  return {
    /**
     * View for users
     * @param {UserRequest} UserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersCreate(
      UserRequest: UserRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersCreate(
        UserRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersCreate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for users
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersDestroy(
      username: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersDestroy(
        username,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersDestroy"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersList(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.usersList(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersList"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * User retrieve and update viewsets for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersMeRetrieve(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUser>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.usersMeRetrieve(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersMeRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for users
     * @param {string} username
     * @param {PatchedUserRequest} [PatchedUserRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersPartialUpdate(
      username: string,
      PatchedUserRequest?: PatchedUserRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.usersPartialUpdate(
          username,
          PatchedUserRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for users
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersRetrieve(
      username: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersRetrieve(
        username,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * View for users
     * @param {string} username
     * @param {UserRequest} UserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUpdate(
      username: string,
      UserRequest: UserRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUpdate(
        username,
        UserRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["UsersApi.usersUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UsersApiFp(configuration)
  return {
    /**
     * View for users
     * @param {UsersApiUsersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCreate(
      requestParameters: UsersApiUsersCreateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<User> {
      return localVarFp
        .usersCreate(requestParameters.UserRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * View for users
     * @param {UsersApiUsersDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersDestroy(
      requestParameters: UsersApiUsersDestroyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .usersDestroy(requestParameters.username, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * View for users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersList(options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
      return localVarFp
        .usersList(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * User retrieve and update viewsets for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeRetrieve(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CurrentUser> {
      return localVarFp
        .usersMeRetrieve(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * View for users
     * @param {UsersApiUsersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersPartialUpdate(
      requestParameters: UsersApiUsersPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<User> {
      return localVarFp
        .usersPartialUpdate(
          requestParameters.username,
          requestParameters.PatchedUserRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * View for users
     * @param {UsersApiUsersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersRetrieve(
      requestParameters: UsersApiUsersRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<User> {
      return localVarFp
        .usersRetrieve(requestParameters.username, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * View for users
     * @param {UsersApiUsersUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUpdate(
      requestParameters: UsersApiUsersUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<User> {
      return localVarFp
        .usersUpdate(
          requestParameters.username,
          requestParameters.UserRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for usersCreate operation in UsersApi.
 */
export interface UsersApiUsersCreateRequest {
  readonly UserRequest: UserRequest
}

/**
 * Request parameters for usersDestroy operation in UsersApi.
 */
export interface UsersApiUsersDestroyRequest {
  readonly username: string
}

/**
 * Request parameters for usersPartialUpdate operation in UsersApi.
 */
export interface UsersApiUsersPartialUpdateRequest {
  readonly username: string

  readonly PatchedUserRequest?: PatchedUserRequest
}

/**
 * Request parameters for usersRetrieve operation in UsersApi.
 */
export interface UsersApiUsersRetrieveRequest {
  readonly username: string
}

/**
 * Request parameters for usersUpdate operation in UsersApi.
 */
export interface UsersApiUsersUpdateRequest {
  readonly username: string

  readonly UserRequest: UserRequest
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
  /**
   * View for users
   * @param {UsersApiUsersCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersCreate(
    requestParameters: UsersApiUsersCreateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .usersCreate(requestParameters.UserRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for users
   * @param {UsersApiUsersDestroyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersDestroy(
    requestParameters: UsersApiUsersDestroyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .usersDestroy(requestParameters.username, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for users
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersList(options?: RawAxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersList(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * User retrieve and update viewsets for the current user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersMeRetrieve(options?: RawAxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersMeRetrieve(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for users
   * @param {UsersApiUsersPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersPartialUpdate(
    requestParameters: UsersApiUsersPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .usersPartialUpdate(
        requestParameters.username,
        requestParameters.PatchedUserRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for users
   * @param {UsersApiUsersRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersRetrieve(
    requestParameters: UsersApiUsersRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .usersRetrieve(requestParameters.username, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * View for users
   * @param {UsersApiUsersUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersUpdate(
    requestParameters: UsersApiUsersUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .usersUpdate(
        requestParameters.username,
        requestParameters.UserRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * VectorContentFilesSearchApi - axios parameter creator
 */
export const VectorContentFilesSearchApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Vector Search for content
     * @summary Content File Vector Search
     * @param {Array<VectorContentFilesSearchRetrieveAggregationsEnum>} [aggregations] aggregations for facet counts               * &#x60;key&#x60; - Key * &#x60;course_number&#x60; - Course Number * &#x60;platform&#x60; - Platform * &#x60;offered_by&#x60; - Offered By * &#x60;file_extension&#x60; - File Extension * &#x60;content_feature_type&#x60; - Content Feature Type * &#x60;run_readable_id&#x60; - Run Readable Id * &#x60;resource_readable_id&#x60; - Resource Readable Id * &#x60;run_title&#x60; - Run Title * &#x60;edx_module_id&#x60; - Edx Module Id * &#x60;content_type&#x60; - Content Type * &#x60;description&#x60; - Description * &#x60;title&#x60; - Title * &#x60;url&#x60; - Url * &#x60;file_type&#x60; - File Type * &#x60;summary&#x60; - Summary * &#x60;flashcards&#x60; - Flashcards * &#x60;checksum&#x60; - Checksum
     * @param {string} [collection_name] Manually specify the name of the Qdrant collection to query
     * @param {Array<string>} [edx_module_id] The edX module id of the content file
     * @param {Array<string>} [file_extension] The extension of the content file.
     * @param {string} [group_by] The attribute to group results by
     * @param {number} [group_size] The number of chunks in each group. Only relevant when group_by is used
     * @param {boolean} [hybrid_search] Whether to use a hybrid search
     * @param {Array<string>} [key] The filename of the content file
     * @param {number} [limit] Number of results to return per page
     * @param {Array<string>} [offered_by] Offeror of the content file
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<string>} [platform] platform(s) of the content file
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_readable_id] The readable_id value of the parent learning resource for the content file
     * @param {Array<string>} [run_readable_id] The readable_id value of the run that the content file belongs to
     * @param {boolean | null} [title__isnull] Filter to content files where title is null/not null
     * @param {boolean | null} [url__isnull] Filter to content files where url is null/not null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vectorContentFilesSearchRetrieve: async (
      aggregations?: Array<VectorContentFilesSearchRetrieveAggregationsEnum>,
      collection_name?: string,
      edx_module_id?: Array<string>,
      file_extension?: Array<string>,
      group_by?: string,
      group_size?: number,
      hybrid_search?: boolean,
      key?: Array<string>,
      limit?: number,
      offered_by?: Array<string>,
      offset?: number,
      platform?: Array<string>,
      q?: string,
      resource_readable_id?: Array<string>,
      run_readable_id?: Array<string>,
      title__isnull?: boolean | null,
      url__isnull?: boolean | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/vector_content_files_search/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (aggregations) {
        localVarQueryParameter["aggregations"] = aggregations
      }

      if (collection_name !== undefined) {
        localVarQueryParameter["collection_name"] = collection_name
      }

      if (edx_module_id) {
        localVarQueryParameter["edx_module_id"] = edx_module_id
      }

      if (file_extension) {
        localVarQueryParameter["file_extension"] = file_extension
      }

      if (group_by !== undefined) {
        localVarQueryParameter["group_by"] = group_by
      }

      if (group_size !== undefined) {
        localVarQueryParameter["group_size"] = group_size
      }

      if (hybrid_search !== undefined) {
        localVarQueryParameter["hybrid_search"] = hybrid_search
      }

      if (key) {
        localVarQueryParameter["key"] = key
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (q !== undefined) {
        localVarQueryParameter["q"] = q
      }

      if (resource_readable_id) {
        localVarQueryParameter["resource_readable_id"] = resource_readable_id
      }

      if (run_readable_id) {
        localVarQueryParameter["run_readable_id"] = run_readable_id
      }

      if (title__isnull !== undefined) {
        localVarQueryParameter["title__isnull"] = title__isnull
      }

      if (url__isnull !== undefined) {
        localVarQueryParameter["url__isnull"] = url__isnull
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * VectorContentFilesSearchApi - functional programming interface
 */
export const VectorContentFilesSearchApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    VectorContentFilesSearchApiAxiosParamCreator(configuration)
  return {
    /**
     * Vector Search for content
     * @summary Content File Vector Search
     * @param {Array<VectorContentFilesSearchRetrieveAggregationsEnum>} [aggregations] aggregations for facet counts               * &#x60;key&#x60; - Key * &#x60;course_number&#x60; - Course Number * &#x60;platform&#x60; - Platform * &#x60;offered_by&#x60; - Offered By * &#x60;file_extension&#x60; - File Extension * &#x60;content_feature_type&#x60; - Content Feature Type * &#x60;run_readable_id&#x60; - Run Readable Id * &#x60;resource_readable_id&#x60; - Resource Readable Id * &#x60;run_title&#x60; - Run Title * &#x60;edx_module_id&#x60; - Edx Module Id * &#x60;content_type&#x60; - Content Type * &#x60;description&#x60; - Description * &#x60;title&#x60; - Title * &#x60;url&#x60; - Url * &#x60;file_type&#x60; - File Type * &#x60;summary&#x60; - Summary * &#x60;flashcards&#x60; - Flashcards * &#x60;checksum&#x60; - Checksum
     * @param {string} [collection_name] Manually specify the name of the Qdrant collection to query
     * @param {Array<string>} [edx_module_id] The edX module id of the content file
     * @param {Array<string>} [file_extension] The extension of the content file.
     * @param {string} [group_by] The attribute to group results by
     * @param {number} [group_size] The number of chunks in each group. Only relevant when group_by is used
     * @param {boolean} [hybrid_search] Whether to use a hybrid search
     * @param {Array<string>} [key] The filename of the content file
     * @param {number} [limit] Number of results to return per page
     * @param {Array<string>} [offered_by] Offeror of the content file
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<string>} [platform] platform(s) of the content file
     * @param {string} [q] The search text
     * @param {Array<string>} [resource_readable_id] The readable_id value of the parent learning resource for the content file
     * @param {Array<string>} [run_readable_id] The readable_id value of the run that the content file belongs to
     * @param {boolean | null} [title__isnull] Filter to content files where title is null/not null
     * @param {boolean | null} [url__isnull] Filter to content files where url is null/not null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async vectorContentFilesSearchRetrieve(
      aggregations?: Array<VectorContentFilesSearchRetrieveAggregationsEnum>,
      collection_name?: string,
      edx_module_id?: Array<string>,
      file_extension?: Array<string>,
      group_by?: string,
      group_size?: number,
      hybrid_search?: boolean,
      key?: Array<string>,
      limit?: number,
      offered_by?: Array<string>,
      offset?: number,
      platform?: Array<string>,
      q?: string,
      resource_readable_id?: Array<string>,
      run_readable_id?: Array<string>,
      title__isnull?: boolean | null,
      url__isnull?: boolean | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ContentFileVectorSearchResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.vectorContentFilesSearchRetrieve(
          aggregations,
          collection_name,
          edx_module_id,
          file_extension,
          group_by,
          group_size,
          hybrid_search,
          key,
          limit,
          offered_by,
          offset,
          platform,
          q,
          resource_readable_id,
          run_readable_id,
          title__isnull,
          url__isnull,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "VectorContentFilesSearchApi.vectorContentFilesSearchRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * VectorContentFilesSearchApi - factory interface
 */
export const VectorContentFilesSearchApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = VectorContentFilesSearchApiFp(configuration)
  return {
    /**
     * Vector Search for content
     * @summary Content File Vector Search
     * @param {VectorContentFilesSearchApiVectorContentFilesSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vectorContentFilesSearchRetrieve(
      requestParameters: VectorContentFilesSearchApiVectorContentFilesSearchRetrieveRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ContentFileVectorSearchResponse> {
      return localVarFp
        .vectorContentFilesSearchRetrieve(
          requestParameters.aggregations,
          requestParameters.collection_name,
          requestParameters.edx_module_id,
          requestParameters.file_extension,
          requestParameters.group_by,
          requestParameters.group_size,
          requestParameters.hybrid_search,
          requestParameters.key,
          requestParameters.limit,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.q,
          requestParameters.resource_readable_id,
          requestParameters.run_readable_id,
          requestParameters.title__isnull,
          requestParameters.url__isnull,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for vectorContentFilesSearchRetrieve operation in VectorContentFilesSearchApi.
 */
export interface VectorContentFilesSearchApiVectorContentFilesSearchRetrieveRequest {
  /**
   * aggregations for facet counts               * &#x60;key&#x60; - Key * &#x60;course_number&#x60; - Course Number * &#x60;platform&#x60; - Platform * &#x60;offered_by&#x60; - Offered By * &#x60;file_extension&#x60; - File Extension * &#x60;content_feature_type&#x60; - Content Feature Type * &#x60;run_readable_id&#x60; - Run Readable Id * &#x60;resource_readable_id&#x60; - Resource Readable Id * &#x60;run_title&#x60; - Run Title * &#x60;edx_module_id&#x60; - Edx Module Id * &#x60;content_type&#x60; - Content Type * &#x60;description&#x60; - Description * &#x60;title&#x60; - Title * &#x60;url&#x60; - Url * &#x60;file_type&#x60; - File Type * &#x60;summary&#x60; - Summary * &#x60;flashcards&#x60; - Flashcards * &#x60;checksum&#x60; - Checksum
   */
  readonly aggregations?: Array<VectorContentFilesSearchRetrieveAggregationsEnum>

  /**
   * Manually specify the name of the Qdrant collection to query
   */
  readonly collection_name?: string

  /**
   * The edX module id of the content file
   */
  readonly edx_module_id?: Array<string>

  /**
   * The extension of the content file.
   */
  readonly file_extension?: Array<string>

  /**
   * The attribute to group results by
   */
  readonly group_by?: string

  /**
   * The number of chunks in each group. Only relevant when group_by is used
   */
  readonly group_size?: number

  /**
   * Whether to use a hybrid search
   */
  readonly hybrid_search?: boolean

  /**
   * The filename of the content file
   */
  readonly key?: Array<string>

  /**
   * Number of results to return per page
   */
  readonly limit?: number

  /**
   * Offeror of the content file
   */
  readonly offered_by?: Array<string>

  /**
   * The initial index from which to return the results
   */
  readonly offset?: number

  /**
   * platform(s) of the content file
   */
  readonly platform?: Array<string>

  /**
   * The search text
   */
  readonly q?: string

  /**
   * The readable_id value of the parent learning resource for the content file
   */
  readonly resource_readable_id?: Array<string>

  /**
   * The readable_id value of the run that the content file belongs to
   */
  readonly run_readable_id?: Array<string>

  /**
   * Filter to content files where title is null/not null
   */
  readonly title__isnull?: boolean | null

  /**
   * Filter to content files where url is null/not null
   */
  readonly url__isnull?: boolean | null
}

/**
 * VectorContentFilesSearchApi - object-oriented interface
 */
export class VectorContentFilesSearchApi extends BaseAPI {
  /**
   * Vector Search for content
   * @summary Content File Vector Search
   * @param {VectorContentFilesSearchApiVectorContentFilesSearchRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public vectorContentFilesSearchRetrieve(
    requestParameters: VectorContentFilesSearchApiVectorContentFilesSearchRetrieveRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return VectorContentFilesSearchApiFp(this.configuration)
      .vectorContentFilesSearchRetrieve(
        requestParameters.aggregations,
        requestParameters.collection_name,
        requestParameters.edx_module_id,
        requestParameters.file_extension,
        requestParameters.group_by,
        requestParameters.group_size,
        requestParameters.hybrid_search,
        requestParameters.key,
        requestParameters.limit,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.q,
        requestParameters.resource_readable_id,
        requestParameters.run_readable_id,
        requestParameters.title__isnull,
        requestParameters.url__isnull,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const VectorContentFilesSearchRetrieveAggregationsEnum = {
  Key: "key",
  CourseNumber: "course_number",
  Platform: "platform",
  OfferedBy: "offered_by",
  FileExtension: "file_extension",
  ContentFeatureType: "content_feature_type",
  RunReadableId: "run_readable_id",
  ResourceReadableId: "resource_readable_id",
  RunTitle: "run_title",
  EdxModuleId: "edx_module_id",
  ContentType: "content_type",
  Description: "description",
  Title: "title",
  Url: "url",
  FileType: "file_type",
  Summary: "summary",
  Flashcards: "flashcards",
  Checksum: "checksum",
} as const
export type VectorContentFilesSearchRetrieveAggregationsEnum =
  (typeof VectorContentFilesSearchRetrieveAggregationsEnum)[keyof typeof VectorContentFilesSearchRetrieveAggregationsEnum]

/**
 * VectorLearningResourcesSearchApi - axios parameter creator
 */
export const VectorLearningResourcesSearchApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Vector Search for learning resources
     * @summary Vector Search
     * @param {Array<VectorLearningResourcesSearchRetrieveAggregationsEnum>} [aggregations] aggregations for facet counts               * &#x60;readable_id&#x60; - Readable Id * &#x60;resource_type&#x60; - Resource Type * &#x60;certification&#x60; - Certification * &#x60;certification_type&#x60; - Certification Type * &#x60;professional&#x60; - Professional * &#x60;free&#x60; - Free * &#x60;course_feature&#x60; - Course Feature * &#x60;topic&#x60; - Topic * &#x60;ocw_topic&#x60; - Ocw Topic * &#x60;level&#x60; - Level * &#x60;department&#x60; - Department * &#x60;platform&#x60; - Platform * &#x60;offered_by&#x60; - Offered By * &#x60;delivery&#x60; - Delivery * &#x60;title&#x60; - Title * &#x60;url&#x60; - Url * &#x60;resource_type_group&#x60; - Resource Type Group * &#x60;resource_category&#x60; - Resource Category * &#x60;published&#x60; - Published * &#x60;next_start_date&#x60; - Next Start Date * &#x60;views&#x60; - Views * &#x60;created_on&#x60; - Created On
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<VectorLearningResourcesSearchRetrieveCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [completeness_penalty] Fraction of its own score a resource with completeness 0 gives up, scaled linearly by incompleteness. 0 disables the penalty. Defaults to the server\&#39;s configured weight when omitted.
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<VectorLearningResourcesSearchRetrieveDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<VectorLearningResourcesSearchRetrieveDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [free]
     * @param {boolean} [hybrid_search] Whether to use a hybrid search
     * @param {Array<VectorLearningResourcesSearchRetrieveLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<VectorLearningResourcesSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<VectorLearningResourcesSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {number | null} [program_boost] Fraction of its own score a program gains before ranking, so 0.1 multiplies it by 1.1 and a program can only overtake a result it was already within that factor of. 0 disables the boost. Defaults to the server\&#39;s configured amount when omitted.
     * @param {string} [q] The search text
     * @param {string} [readable_id] The readable id of the resource
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<VectorLearningResourcesSearchRetrieveResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum>} [resource_type_group] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {number} [score_cutoff] The minimum absolute score a result must have to be returned. Defaults to 0.0 when omitted, but the server clamps the effective cutoff to the minimum allowed for the selected search mode (dense or hybrid). This is only the backstop for a query that matched nothing; score_cutoff_ratio is what shapes a result set.
     * @param {number | null} [score_cutoff_ratio] Fraction of the query\&#39;s own best score a result must reach to be returned, applied after score_cutoff so the size of a result set follows how fast relevance falls off within the query. 0 disables the relative cutoff. Defaults to the server\&#39;s configured ratio for the selected search mode (dense or hybrid) when omitted.
     * @param {VectorLearningResourcesSearchRetrieveSortbyEnum} [sortby] if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;next_start_date&#x60; - next_start_date * &#x60;views&#x60; - views * &#x60;created_on&#x60; - created_on * &#x60;-next_start_date&#x60; - -next_start_date * &#x60;-views&#x60; - -views * &#x60;-created_on&#x60; - -created_on
     * @param {number | null} [staleness_horizon_years] Age in years at which a resource takes the full staleness penalty, with the penalty ramping linearly up to it. 0 disables the penalty. Defaults to the server\&#39;s configured horizon when omitted.
     * @param {number | null} [staleness_penalty] Fraction of its own score a resource gives up once it is at or beyond the staleness horizon, ramped linearly by age. Resources with an upcoming run are exempt. 0 disables the penalty. Defaults to the server\&#39;s configured weight when omitted.
     * @param {boolean | null} [title__isnull] Filter to learning resources where title is null/not null
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {boolean | null} [url__isnull] Filter to learning resources where url is null/not null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vectorLearningResourcesSearchRetrieve: async (
      aggregations?: Array<VectorLearningResourcesSearchRetrieveAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<VectorLearningResourcesSearchRetrieveCertificationTypeEnum>,
      completeness_penalty?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<VectorLearningResourcesSearchRetrieveDeliveryEnum>,
      department?: Array<VectorLearningResourcesSearchRetrieveDepartmentEnum>,
      free?: boolean | null,
      hybrid_search?: boolean,
      level?: Array<VectorLearningResourcesSearchRetrieveLevelEnum>,
      limit?: number,
      ocw_topic?: Array<string>,
      offered_by?: Array<VectorLearningResourcesSearchRetrieveOfferedByEnum>,
      offset?: number,
      platform?: Array<VectorLearningResourcesSearchRetrievePlatformEnum>,
      professional?: boolean | null,
      program_boost?: number | null,
      q?: string,
      readable_id?: string,
      resource_category?: Array<string>,
      resource_type?: Array<VectorLearningResourcesSearchRetrieveResourceTypeEnum>,
      resource_type_group?: Array<VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum>,
      score_cutoff?: number,
      score_cutoff_ratio?: number | null,
      sortby?: VectorLearningResourcesSearchRetrieveSortbyEnum,
      staleness_horizon_years?: number | null,
      staleness_penalty?: number | null,
      title__isnull?: boolean | null,
      topic?: Array<string>,
      url__isnull?: boolean | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v0/vector_learning_resources_search/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (aggregations) {
        localVarQueryParameter["aggregations"] = aggregations
      }

      if (certification !== undefined) {
        localVarQueryParameter["certification"] = certification
      }

      if (certification_type) {
        localVarQueryParameter["certification_type"] = certification_type
      }

      if (completeness_penalty !== undefined) {
        localVarQueryParameter["completeness_penalty"] = completeness_penalty
      }

      if (course_feature) {
        localVarQueryParameter["course_feature"] = course_feature
      }

      if (delivery) {
        localVarQueryParameter["delivery"] = delivery
      }

      if (department) {
        localVarQueryParameter["department"] = department
      }

      if (free !== undefined) {
        localVarQueryParameter["free"] = free
      }

      if (hybrid_search !== undefined) {
        localVarQueryParameter["hybrid_search"] = hybrid_search
      }

      if (level) {
        localVarQueryParameter["level"] = level
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit
      }

      if (ocw_topic) {
        localVarQueryParameter["ocw_topic"] = ocw_topic
      }

      if (offered_by) {
        localVarQueryParameter["offered_by"] = offered_by
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset
      }

      if (platform) {
        localVarQueryParameter["platform"] = platform
      }

      if (professional !== undefined) {
        localVarQueryParameter["professional"] = professional
      }

      if (program_boost !== undefined) {
        localVarQueryParameter["program_boost"] = program_boost
      }

      if (q !== undefined) {
        localVarQueryParameter["q"] = q
      }

      if (readable_id !== undefined) {
        localVarQueryParameter["readable_id"] = readable_id
      }

      if (resource_category) {
        localVarQueryParameter["resource_category"] = resource_category
      }

      if (resource_type) {
        localVarQueryParameter["resource_type"] = resource_type
      }

      if (resource_type_group) {
        localVarQueryParameter["resource_type_group"] = resource_type_group
      }

      if (score_cutoff !== undefined) {
        localVarQueryParameter["score_cutoff"] = score_cutoff
      }

      if (score_cutoff_ratio !== undefined) {
        localVarQueryParameter["score_cutoff_ratio"] = score_cutoff_ratio
      }

      if (sortby !== undefined) {
        localVarQueryParameter["sortby"] = sortby
      }

      if (staleness_horizon_years !== undefined) {
        localVarQueryParameter["staleness_horizon_years"] =
          staleness_horizon_years
      }

      if (staleness_penalty !== undefined) {
        localVarQueryParameter["staleness_penalty"] = staleness_penalty
      }

      if (title__isnull !== undefined) {
        localVarQueryParameter["title__isnull"] = title__isnull
      }

      if (topic) {
        localVarQueryParameter["topic"] = topic
      }

      if (url__isnull !== undefined) {
        localVarQueryParameter["url__isnull"] = url__isnull
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * VectorLearningResourcesSearchApi - functional programming interface
 */
export const VectorLearningResourcesSearchApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    VectorLearningResourcesSearchApiAxiosParamCreator(configuration)
  return {
    /**
     * Vector Search for learning resources
     * @summary Vector Search
     * @param {Array<VectorLearningResourcesSearchRetrieveAggregationsEnum>} [aggregations] aggregations for facet counts               * &#x60;readable_id&#x60; - Readable Id * &#x60;resource_type&#x60; - Resource Type * &#x60;certification&#x60; - Certification * &#x60;certification_type&#x60; - Certification Type * &#x60;professional&#x60; - Professional * &#x60;free&#x60; - Free * &#x60;course_feature&#x60; - Course Feature * &#x60;topic&#x60; - Topic * &#x60;ocw_topic&#x60; - Ocw Topic * &#x60;level&#x60; - Level * &#x60;department&#x60; - Department * &#x60;platform&#x60; - Platform * &#x60;offered_by&#x60; - Offered By * &#x60;delivery&#x60; - Delivery * &#x60;title&#x60; - Title * &#x60;url&#x60; - Url * &#x60;resource_type_group&#x60; - Resource Type Group * &#x60;resource_category&#x60; - Resource Category * &#x60;published&#x60; - Published * &#x60;next_start_date&#x60; - Next Start Date * &#x60;views&#x60; - Views * &#x60;created_on&#x60; - Created On
     * @param {boolean | null} [certification] True if the learning resource offers a certificate
     * @param {Array<VectorLearningResourcesSearchRetrieveCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
     * @param {number | null} [completeness_penalty] Fraction of its own score a resource with completeness 0 gives up, scaled linearly by incompleteness. 0 disables the penalty. Defaults to the server\&#39;s configured weight when omitted.
     * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
     * @param {Array<VectorLearningResourcesSearchRetrieveDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
     * @param {Array<VectorLearningResourcesSearchRetrieveDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
     * @param {boolean | null} [free]
     * @param {boolean} [hybrid_search] Whether to use a hybrid search
     * @param {Array<VectorLearningResourcesSearchRetrieveLevelEnum>} [level]
     * @param {number} [limit] Number of results to return per page
     * @param {Array<string>} [ocw_topic] The ocw topic name.
     * @param {Array<VectorLearningResourcesSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
     * @param {number} [offset] The initial index from which to return the results
     * @param {Array<VectorLearningResourcesSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
     * @param {boolean | null} [professional]
     * @param {number | null} [program_boost] Fraction of its own score a program gains before ranking, so 0.1 multiplies it by 1.1 and a program can only overtake a result it was already within that factor of. 0 disables the boost. Defaults to the server\&#39;s configured amount when omitted.
     * @param {string} [q] The search text
     * @param {string} [readable_id] The readable id of the resource
     * @param {Array<string>} [resource_category] The resource category for the resource
     * @param {Array<VectorLearningResourcesSearchRetrieveResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
     * @param {Array<VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum>} [resource_type_group] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
     * @param {number} [score_cutoff] The minimum absolute score a result must have to be returned. Defaults to 0.0 when omitted, but the server clamps the effective cutoff to the minimum allowed for the selected search mode (dense or hybrid). This is only the backstop for a query that matched nothing; score_cutoff_ratio is what shapes a result set.
     * @param {number | null} [score_cutoff_ratio] Fraction of the query\&#39;s own best score a result must reach to be returned, applied after score_cutoff so the size of a result set follows how fast relevance falls off within the query. 0 disables the relative cutoff. Defaults to the server\&#39;s configured ratio for the selected search mode (dense or hybrid) when omitted.
     * @param {VectorLearningResourcesSearchRetrieveSortbyEnum} [sortby] if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;next_start_date&#x60; - next_start_date * &#x60;views&#x60; - views * &#x60;created_on&#x60; - created_on * &#x60;-next_start_date&#x60; - -next_start_date * &#x60;-views&#x60; - -views * &#x60;-created_on&#x60; - -created_on
     * @param {number | null} [staleness_horizon_years] Age in years at which a resource takes the full staleness penalty, with the penalty ramping linearly up to it. 0 disables the penalty. Defaults to the server\&#39;s configured horizon when omitted.
     * @param {number | null} [staleness_penalty] Fraction of its own score a resource gives up once it is at or beyond the staleness horizon, ramped linearly by age. Resources with an upcoming run are exempt. 0 disables the penalty. Defaults to the server\&#39;s configured weight when omitted.
     * @param {boolean | null} [title__isnull] Filter to learning resources where title is null/not null
     * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
     * @param {boolean | null} [url__isnull] Filter to learning resources where url is null/not null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async vectorLearningResourcesSearchRetrieve(
      aggregations?: Array<VectorLearningResourcesSearchRetrieveAggregationsEnum>,
      certification?: boolean | null,
      certification_type?: Array<VectorLearningResourcesSearchRetrieveCertificationTypeEnum>,
      completeness_penalty?: number | null,
      course_feature?: Array<string>,
      delivery?: Array<VectorLearningResourcesSearchRetrieveDeliveryEnum>,
      department?: Array<VectorLearningResourcesSearchRetrieveDepartmentEnum>,
      free?: boolean | null,
      hybrid_search?: boolean,
      level?: Array<VectorLearningResourcesSearchRetrieveLevelEnum>,
      limit?: number,
      ocw_topic?: Array<string>,
      offered_by?: Array<VectorLearningResourcesSearchRetrieveOfferedByEnum>,
      offset?: number,
      platform?: Array<VectorLearningResourcesSearchRetrievePlatformEnum>,
      professional?: boolean | null,
      program_boost?: number | null,
      q?: string,
      readable_id?: string,
      resource_category?: Array<string>,
      resource_type?: Array<VectorLearningResourcesSearchRetrieveResourceTypeEnum>,
      resource_type_group?: Array<VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum>,
      score_cutoff?: number,
      score_cutoff_ratio?: number | null,
      sortby?: VectorLearningResourcesSearchRetrieveSortbyEnum,
      staleness_horizon_years?: number | null,
      staleness_penalty?: number | null,
      title__isnull?: boolean | null,
      topic?: Array<string>,
      url__isnull?: boolean | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LearningResourcesVectorSearchResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.vectorLearningResourcesSearchRetrieve(
          aggregations,
          certification,
          certification_type,
          completeness_penalty,
          course_feature,
          delivery,
          department,
          free,
          hybrid_search,
          level,
          limit,
          ocw_topic,
          offered_by,
          offset,
          platform,
          professional,
          program_boost,
          q,
          readable_id,
          resource_category,
          resource_type,
          resource_type_group,
          score_cutoff,
          score_cutoff_ratio,
          sortby,
          staleness_horizon_years,
          staleness_penalty,
          title__isnull,
          topic,
          url__isnull,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          "VectorLearningResourcesSearchApi.vectorLearningResourcesSearchRetrieve"
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * VectorLearningResourcesSearchApi - factory interface
 */
export const VectorLearningResourcesSearchApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = VectorLearningResourcesSearchApiFp(configuration)
  return {
    /**
     * Vector Search for learning resources
     * @summary Vector Search
     * @param {VectorLearningResourcesSearchApiVectorLearningResourcesSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    vectorLearningResourcesSearchRetrieve(
      requestParameters: VectorLearningResourcesSearchApiVectorLearningResourcesSearchRetrieveRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LearningResourcesVectorSearchResponse> {
      return localVarFp
        .vectorLearningResourcesSearchRetrieve(
          requestParameters.aggregations,
          requestParameters.certification,
          requestParameters.certification_type,
          requestParameters.completeness_penalty,
          requestParameters.course_feature,
          requestParameters.delivery,
          requestParameters.department,
          requestParameters.free,
          requestParameters.hybrid_search,
          requestParameters.level,
          requestParameters.limit,
          requestParameters.ocw_topic,
          requestParameters.offered_by,
          requestParameters.offset,
          requestParameters.platform,
          requestParameters.professional,
          requestParameters.program_boost,
          requestParameters.q,
          requestParameters.readable_id,
          requestParameters.resource_category,
          requestParameters.resource_type,
          requestParameters.resource_type_group,
          requestParameters.score_cutoff,
          requestParameters.score_cutoff_ratio,
          requestParameters.sortby,
          requestParameters.staleness_horizon_years,
          requestParameters.staleness_penalty,
          requestParameters.title__isnull,
          requestParameters.topic,
          requestParameters.url__isnull,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for vectorLearningResourcesSearchRetrieve operation in VectorLearningResourcesSearchApi.
 */
export interface VectorLearningResourcesSearchApiVectorLearningResourcesSearchRetrieveRequest {
  /**
   * aggregations for facet counts               * &#x60;readable_id&#x60; - Readable Id * &#x60;resource_type&#x60; - Resource Type * &#x60;certification&#x60; - Certification * &#x60;certification_type&#x60; - Certification Type * &#x60;professional&#x60; - Professional * &#x60;free&#x60; - Free * &#x60;course_feature&#x60; - Course Feature * &#x60;topic&#x60; - Topic * &#x60;ocw_topic&#x60; - Ocw Topic * &#x60;level&#x60; - Level * &#x60;department&#x60; - Department * &#x60;platform&#x60; - Platform * &#x60;offered_by&#x60; - Offered By * &#x60;delivery&#x60; - Delivery * &#x60;title&#x60; - Title * &#x60;url&#x60; - Url * &#x60;resource_type_group&#x60; - Resource Type Group * &#x60;resource_category&#x60; - Resource Category * &#x60;published&#x60; - Published * &#x60;next_start_date&#x60; - Next Start Date * &#x60;views&#x60; - Views * &#x60;created_on&#x60; - Created On
   */
  readonly aggregations?: Array<VectorLearningResourcesSearchRetrieveAggregationsEnum>

  /**
   * True if the learning resource offers a certificate
   */
  readonly certification?: boolean | null

  /**
   * The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
   */
  readonly certification_type?: Array<VectorLearningResourcesSearchRetrieveCertificationTypeEnum>

  /**
   * Fraction of its own score a resource with completeness 0 gives up, scaled linearly by incompleteness. 0 disables the penalty. Defaults to the server\&#39;s configured weight when omitted.
   */
  readonly completeness_penalty?: number | null

  /**
   * The course feature. Possible options are at api/v1/course_features/
   */
  readonly course_feature?: Array<string>

  /**
   * The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
   */
  readonly delivery?: Array<VectorLearningResourcesSearchRetrieveDeliveryEnum>

  /**
   * The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music * &#x60;21T&#x60; - Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
   */
  readonly department?: Array<VectorLearningResourcesSearchRetrieveDepartmentEnum>

  readonly free?: boolean | null

  /**
   * Whether to use a hybrid search
   */
  readonly hybrid_search?: boolean

  readonly level?: Array<VectorLearningResourcesSearchRetrieveLevelEnum>

  /**
   * Number of results to return per page
   */
  readonly limit?: number

  /**
   * The ocw topic name.
   */
  readonly ocw_topic?: Array<string>

  /**
   * The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;climate&#x60; - MIT Climate
   */
  readonly offered_by?: Array<VectorLearningResourcesSearchRetrieveOfferedByEnum>

  /**
   * The initial index from which to return the results
   */
  readonly offset?: number

  /**
   * The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube * &#x60;canvas&#x60; - Canvas * &#x60;climate&#x60; - MIT Climate * &#x60;ovs&#x60; - ODL Video Service
   */
  readonly platform?: Array<VectorLearningResourcesSearchRetrievePlatformEnum>

  readonly professional?: boolean | null

  /**
   * Fraction of its own score a program gains before ranking, so 0.1 multiplies it by 1.1 and a program can only overtake a result it was already within that factor of. 0 disables the boost. Defaults to the server\&#39;s configured amount when omitted.
   */
  readonly program_boost?: number | null

  /**
   * The search text
   */
  readonly q?: string

  /**
   * The readable id of the resource
   */
  readonly readable_id?: string

  /**
   * The resource category for the resource
   */
  readonly resource_category?: Array<string>

  /**
   * The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist * &#x60;document&#x60; - document
   */
  readonly resource_type?: Array<VectorLearningResourcesSearchRetrieveResourceTypeEnum>

  /**
   * The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
   */
  readonly resource_type_group?: Array<VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum>

  /**
   * The minimum absolute score a result must have to be returned. Defaults to 0.0 when omitted, but the server clamps the effective cutoff to the minimum allowed for the selected search mode (dense or hybrid). This is only the backstop for a query that matched nothing; score_cutoff_ratio is what shapes a result set.
   */
  readonly score_cutoff?: number

  /**
   * Fraction of the query\&#39;s own best score a result must reach to be returned, applied after score_cutoff so the size of a result set follows how fast relevance falls off within the query. 0 disables the relative cutoff. Defaults to the server\&#39;s configured ratio for the selected search mode (dense or hybrid) when omitted.
   */
  readonly score_cutoff_ratio?: number | null

  /**
   * if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;next_start_date&#x60; - next_start_date * &#x60;views&#x60; - views * &#x60;created_on&#x60; - created_on * &#x60;-next_start_date&#x60; - -next_start_date * &#x60;-views&#x60; - -views * &#x60;-created_on&#x60; - -created_on
   */
  readonly sortby?: VectorLearningResourcesSearchRetrieveSortbyEnum

  /**
   * Age in years at which a resource takes the full staleness penalty, with the penalty ramping linearly up to it. 0 disables the penalty. Defaults to the server\&#39;s configured horizon when omitted.
   */
  readonly staleness_horizon_years?: number | null

  /**
   * Fraction of its own score a resource gives up once it is at or beyond the staleness horizon, ramped linearly by age. Resources with an upcoming run are exempt. 0 disables the penalty. Defaults to the server\&#39;s configured weight when omitted.
   */
  readonly staleness_penalty?: number | null

  /**
   * Filter to learning resources where title is null/not null
   */
  readonly title__isnull?: boolean | null

  /**
   * The topic name. To see a list of options go to api/v1/topics/
   */
  readonly topic?: Array<string>

  /**
   * Filter to learning resources where url is null/not null
   */
  readonly url__isnull?: boolean | null
}

/**
 * VectorLearningResourcesSearchApi - object-oriented interface
 */
export class VectorLearningResourcesSearchApi extends BaseAPI {
  /**
   * Vector Search for learning resources
   * @summary Vector Search
   * @param {VectorLearningResourcesSearchApiVectorLearningResourcesSearchRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public vectorLearningResourcesSearchRetrieve(
    requestParameters: VectorLearningResourcesSearchApiVectorLearningResourcesSearchRetrieveRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return VectorLearningResourcesSearchApiFp(this.configuration)
      .vectorLearningResourcesSearchRetrieve(
        requestParameters.aggregations,
        requestParameters.certification,
        requestParameters.certification_type,
        requestParameters.completeness_penalty,
        requestParameters.course_feature,
        requestParameters.delivery,
        requestParameters.department,
        requestParameters.free,
        requestParameters.hybrid_search,
        requestParameters.level,
        requestParameters.limit,
        requestParameters.ocw_topic,
        requestParameters.offered_by,
        requestParameters.offset,
        requestParameters.platform,
        requestParameters.professional,
        requestParameters.program_boost,
        requestParameters.q,
        requestParameters.readable_id,
        requestParameters.resource_category,
        requestParameters.resource_type,
        requestParameters.resource_type_group,
        requestParameters.score_cutoff,
        requestParameters.score_cutoff_ratio,
        requestParameters.sortby,
        requestParameters.staleness_horizon_years,
        requestParameters.staleness_penalty,
        requestParameters.title__isnull,
        requestParameters.topic,
        requestParameters.url__isnull,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

export const VectorLearningResourcesSearchRetrieveAggregationsEnum = {
  ReadableId: "readable_id",
  ResourceType: "resource_type",
  Certification: "certification",
  CertificationType: "certification_type",
  Professional: "professional",
  Free: "free",
  CourseFeature: "course_feature",
  Topic: "topic",
  OcwTopic: "ocw_topic",
  Level: "level",
  Department: "department",
  Platform: "platform",
  OfferedBy: "offered_by",
  Delivery: "delivery",
  Title: "title",
  Url: "url",
  ResourceTypeGroup: "resource_type_group",
  ResourceCategory: "resource_category",
  Published: "published",
  NextStartDate: "next_start_date",
  Views: "views",
  CreatedOn: "created_on",
} as const
export type VectorLearningResourcesSearchRetrieveAggregationsEnum =
  (typeof VectorLearningResourcesSearchRetrieveAggregationsEnum)[keyof typeof VectorLearningResourcesSearchRetrieveAggregationsEnum]
export const VectorLearningResourcesSearchRetrieveCertificationTypeEnum = {
  Micromasters: "micromasters",
  Professional: "professional",
  Completion: "completion",
  None: "none",
} as const
export type VectorLearningResourcesSearchRetrieveCertificationTypeEnum =
  (typeof VectorLearningResourcesSearchRetrieveCertificationTypeEnum)[keyof typeof VectorLearningResourcesSearchRetrieveCertificationTypeEnum]
export const VectorLearningResourcesSearchRetrieveDeliveryEnum = {
  Online: "online",
  Hybrid: "hybrid",
  InPerson: "in_person",
  Offline: "offline",
} as const
export type VectorLearningResourcesSearchRetrieveDeliveryEnum =
  (typeof VectorLearningResourcesSearchRetrieveDeliveryEnum)[keyof typeof VectorLearningResourcesSearchRetrieveDeliveryEnum]
export const VectorLearningResourcesSearchRetrieveDepartmentEnum = {
  _1: "1",
  _2: "2",
  _3: "3",
  _4: "4",
  _5: "5",
  _6: "6",
  _7: "7",
  _8: "8",
  _9: "9",
  _10: "10",
  _11: "11",
  _12: "12",
  _14: "14",
  _15: "15",
  _16: "16",
  _17: "17",
  _18: "18",
  _20: "20",
  _21A: "21A",
  _21G: "21G",
  _21H: "21H",
  _21L: "21L",
  _21M: "21M",
  _21T: "21T",
  _22: "22",
  _24: "24",
  Cc: "CC",
  CmsW: "CMS-W",
  Ec: "EC",
  Es: "ES",
  Esd: "ESD",
  Hst: "HST",
  Ids: "IDS",
  Mas: "MAS",
  Pe: "PE",
  Sp: "SP",
  Sts: "STS",
  Wgs: "WGS",
} as const
export type VectorLearningResourcesSearchRetrieveDepartmentEnum =
  (typeof VectorLearningResourcesSearchRetrieveDepartmentEnum)[keyof typeof VectorLearningResourcesSearchRetrieveDepartmentEnum]
export const VectorLearningResourcesSearchRetrieveLevelEnum = {
  Undergraduate: "undergraduate",
  Graduate: "graduate",
  HighSchool: "high_school",
  Noncredit: "noncredit",
  Advanced: "advanced",
  Intermediate: "intermediate",
  Introductory: "introductory",
} as const
export type VectorLearningResourcesSearchRetrieveLevelEnum =
  (typeof VectorLearningResourcesSearchRetrieveLevelEnum)[keyof typeof VectorLearningResourcesSearchRetrieveLevelEnum]
export const VectorLearningResourcesSearchRetrieveOfferedByEnum = {
  Mitx: "mitx",
  Ocw: "ocw",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Mitpe: "mitpe",
  See: "see",
  Climate: "climate",
} as const
export type VectorLearningResourcesSearchRetrieveOfferedByEnum =
  (typeof VectorLearningResourcesSearchRetrieveOfferedByEnum)[keyof typeof VectorLearningResourcesSearchRetrieveOfferedByEnum]
export const VectorLearningResourcesSearchRetrievePlatformEnum = {
  Edx: "edx",
  Ocw: "ocw",
  Oll: "oll",
  Mitxonline: "mitxonline",
  Bootcamps: "bootcamps",
  Xpro: "xpro",
  Csail: "csail",
  Mitpe: "mitpe",
  See: "see",
  Scc: "scc",
  Ctl: "ctl",
  Whu: "whu",
  Susskind: "susskind",
  Globalalumni: "globalalumni",
  Simplilearn: "simplilearn",
  Emeritus: "emeritus",
  Podcast: "podcast",
  Youtube: "youtube",
  Canvas: "canvas",
  Climate: "climate",
  Ovs: "ovs",
} as const
export type VectorLearningResourcesSearchRetrievePlatformEnum =
  (typeof VectorLearningResourcesSearchRetrievePlatformEnum)[keyof typeof VectorLearningResourcesSearchRetrievePlatformEnum]
export const VectorLearningResourcesSearchRetrieveResourceTypeEnum = {
  Course: "course",
  Program: "program",
  LearningPath: "learning_path",
  Podcast: "podcast",
  PodcastEpisode: "podcast_episode",
  Video: "video",
  VideoPlaylist: "video_playlist",
  Document: "document",
} as const
export type VectorLearningResourcesSearchRetrieveResourceTypeEnum =
  (typeof VectorLearningResourcesSearchRetrieveResourceTypeEnum)[keyof typeof VectorLearningResourcesSearchRetrieveResourceTypeEnum]
export const VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum = {
  Course: "course",
  Program: "program",
  LearningMaterial: "learning_material",
} as const
export type VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum =
  (typeof VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum)[keyof typeof VectorLearningResourcesSearchRetrieveResourceTypeGroupEnum]
export const VectorLearningResourcesSearchRetrieveSortbyEnum = {
  NextStartDate: "next_start_date",
  Views: "views",
  CreatedOn: "created_on",
  NextStartDate2: "-next_start_date",
  Views2: "-views",
  CreatedOn2: "-created_on",
} as const
export type VectorLearningResourcesSearchRetrieveSortbyEnum =
  (typeof VectorLearningResourcesSearchRetrieveSortbyEnum)[keyof typeof VectorLearningResourcesSearchRetrieveSortbyEnum]

/**
 * WidgetListsApi - axios parameter creator
 */
export const WidgetListsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * API for managing widget lists
     * @param {number} id A unique integer value identifying this widget list.
     * @param {PatchedWidgetListRequest} [PatchedWidgetListRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    widgetListsPartialUpdate: async (
      id: number,
      PatchedWidgetListRequest?: PatchedWidgetListRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("widgetListsPartialUpdate", "id", id)
      const localVarPath = `/api/v0/widget_lists/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        PatchedWidgetListRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * API for managing widget lists
     * @param {number} id A unique integer value identifying this widget list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    widgetListsRetrieve: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("widgetListsRetrieve", "id", id)
      const localVarPath = `/api/v0/widget_lists/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * API for managing widget lists
     * @param {number} id A unique integer value identifying this widget list.
     * @param {WidgetListRequest} [WidgetListRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    widgetListsUpdate: async (
      id: number,
      WidgetListRequest?: WidgetListRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("widgetListsUpdate", "id", id)
      const localVarPath = `/api/v0/widget_lists/{id}/`.replace(
        "{id}",
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        WidgetListRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * WidgetListsApi - functional programming interface
 */
export const WidgetListsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    WidgetListsApiAxiosParamCreator(configuration)
  return {
    /**
     * API for managing widget lists
     * @param {number} id A unique integer value identifying this widget list.
     * @param {PatchedWidgetListRequest} [PatchedWidgetListRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async widgetListsPartialUpdate(
      id: number,
      PatchedWidgetListRequest?: PatchedWidgetListRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.widgetListsPartialUpdate(
          id,
          PatchedWidgetListRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WidgetListsApi.widgetListsPartialUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * API for managing widget lists
     * @param {number} id A unique integer value identifying this widget list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async widgetListsRetrieve(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.widgetListsRetrieve(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WidgetListsApi.widgetListsRetrieve"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * API for managing widget lists
     * @param {number} id A unique integer value identifying this widget list.
     * @param {WidgetListRequest} [WidgetListRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async widgetListsUpdate(
      id: number,
      WidgetListRequest?: WidgetListRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.widgetListsUpdate(
          id,
          WidgetListRequest,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["WidgetListsApi.widgetListsUpdate"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * WidgetListsApi - factory interface
 */
export const WidgetListsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WidgetListsApiFp(configuration)
  return {
    /**
     * API for managing widget lists
     * @param {WidgetListsApiWidgetListsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    widgetListsPartialUpdate(
      requestParameters: WidgetListsApiWidgetListsPartialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WidgetList> {
      return localVarFp
        .widgetListsPartialUpdate(
          requestParameters.id,
          requestParameters.PatchedWidgetListRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * API for managing widget lists
     * @param {WidgetListsApiWidgetListsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    widgetListsRetrieve(
      requestParameters: WidgetListsApiWidgetListsRetrieveRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WidgetList> {
      return localVarFp
        .widgetListsRetrieve(requestParameters.id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * API for managing widget lists
     * @param {WidgetListsApiWidgetListsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    widgetListsUpdate(
      requestParameters: WidgetListsApiWidgetListsUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<WidgetList> {
      return localVarFp
        .widgetListsUpdate(
          requestParameters.id,
          requestParameters.WidgetListRequest,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for widgetListsPartialUpdate operation in WidgetListsApi.
 */
export interface WidgetListsApiWidgetListsPartialUpdateRequest {
  /**
   * A unique integer value identifying this widget list.
   */
  readonly id: number

  readonly PatchedWidgetListRequest?: PatchedWidgetListRequest
}

/**
 * Request parameters for widgetListsRetrieve operation in WidgetListsApi.
 */
export interface WidgetListsApiWidgetListsRetrieveRequest {
  /**
   * A unique integer value identifying this widget list.
   */
  readonly id: number
}

/**
 * Request parameters for widgetListsUpdate operation in WidgetListsApi.
 */
export interface WidgetListsApiWidgetListsUpdateRequest {
  /**
   * A unique integer value identifying this widget list.
   */
  readonly id: number

  readonly WidgetListRequest?: WidgetListRequest
}

/**
 * WidgetListsApi - object-oriented interface
 */
export class WidgetListsApi extends BaseAPI {
  /**
   * API for managing widget lists
   * @param {WidgetListsApiWidgetListsPartialUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public widgetListsPartialUpdate(
    requestParameters: WidgetListsApiWidgetListsPartialUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WidgetListsApiFp(this.configuration)
      .widgetListsPartialUpdate(
        requestParameters.id,
        requestParameters.PatchedWidgetListRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * API for managing widget lists
   * @param {WidgetListsApiWidgetListsRetrieveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public widgetListsRetrieve(
    requestParameters: WidgetListsApiWidgetListsRetrieveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WidgetListsApiFp(this.configuration)
      .widgetListsRetrieve(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * API for managing widget lists
   * @param {WidgetListsApiWidgetListsUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public widgetListsUpdate(
    requestParameters: WidgetListsApiWidgetListsUpdateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WidgetListsApiFp(this.configuration)
      .widgetListsUpdate(
        requestParameters.id,
        requestParameters.WidgetListRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}
